/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
import React, { Component, Fragment, useContext } from "react";
import PropTypes from "prop-types";
import _, { first } from "lodash";
import { validateEmailList} from "../billing_screen/helpers";
import {
  Col,
  FormItem,
  Input,
  Row,
  Button,
  Alert,
  Popconfirm,
  Icon,
  Typography,
  Tooltip,
  Card,
  Modal,
  Divider,
  Select,
  Spin,
  Empty,
  message,
  Drawer,
  Tabs,
  Search,
  DatePicker,
  Checkbox,
} from "../../common/UIComponents";
import {
  alertMessage,
  findTotal,
  doValidate,
  checkNegitive,
  isEmpty,
  findNumberTotal,
  customPasteSplit,
  doFormate,
  compareString,
  ellipseText,
} from "../../common/Common";
import I18n from "../../common/I18n";
import FormattedErrors from "../common/FormattedErrors";
import FormErrors from "../common/FormErrors";
import InvoicesItemList from "./InvoicesItemList";
import Remarks from "./Remarks";
import {
  changeInvoiceStatus,
  deleteInvoiceLine,
  updateInvoice,
  updateInvoiceLines,
  saveNewInvoice,
  saveInvoiceDetailsForm,
  addOrdersForBillingGroup,
  removeOrderFromBillingGroup,
  applyFMP,
  applySMP,
  getContactEmails,
  reapproveBillings,
  updateInvoiceCharges,
  fetchBillingDetails,
  fetchQuotationDetails,
  saveInvoice,
  fetchManualBillingDetails,
  regenerateInvoiceWithNewLos,
  changeStatusOfInvoicesToHold,
  getBillingActivities,
  saveTemplateZoneForm,
  getEmailSubjectLine,
  saveHawbChangedDate,
  updateFuelPercentage,
  updateModifyStatus,
  savePaperWork,
  SendInvoiceEmail,
  approveBillingPaperwork,
} from "../../api/Billing";
import {
  fetchAccountAccessorials,
  fetchAccountConfigs,
  fetchOrderTypeLos,
} from "../../api/Account";
import BaseModal from "../BaseModal";
import InvoiceHeader from "./Header";
import { fetchAccountShortLos } from "../../api/Los";
import userStore from "../../stores/UserStore";
import UploadGallery from "../common/UploadGallery";
import Documents from "../../stories/components/Documents";
import AppConfig from "../../config/AppConfig";
import { fetchOrganizationDetails } from "../../api/Organisations";
import {
  checkAccessExistance,
  checkServiceExistance,
  confirmationPopup,
  convertToUnitsWithBothLabels,
  formatByTimeConfig,
  formatFullName,
  getFormattedWeight,
  getWeightWithBothUnits,
  renderAlertMessage,
  updatePicSettingsWithBol,
} from "../../helpers/common";
import CustomerOrderDetails from "../orders/CustomerOrderDetails";
import OrderPriceTypePopover from "./OrderPriceTypePopover";
import ApproveInvoices from "./ApproveInvoices";
import TagsInput from "react-tagsinput";
import { getFMPOrderFromInvoice, showFMP } from "../../helpers/billing";
import moment from "moment";
import { deleteOrderPic, fetchOrderAccessorials, fetchOrderDetails, uploadPod } from "../../api/OrdersApi";
import { renderDriverNotes, setAccessorialResponse } from "../../helpers/orders";
import { DriverSelect } from "../common/SelectDropdowns/BaseSelect";
import SwitchComponent from "../../common/switchComponent";
import BillingPdfDownload from "./BillingPdfDownload";
import BillingActionButtons from "./BillingActionButtons";
import EmailsInput from "../../containers/Modals/EmailsInput";
import ConsolidationButton from "./ConsolidateButton";
import BillingDrivers from "./BillingDrivers";
import { withRouter } from "react-router-dom";
import { WarehouseContext } from "../../context/WarehouseContext";
import { OrgContext } from "../../context/OrgContext";
import { UserContext } from "../../context/UserContext";
import EditOrderFormComponent from "../orders/EditOrderForm";
import OrderQuantity from "../preplan/OrderQuantity";
import AccessorialCharges from "../../containers/AccessorialCharges";
import { fetchDriverList, fetchTechnicians, fetchUsers } from "../../api/UsersApi";
import DriverPayDetails from "./DriverPayDetails";
import BillingDriverPay from "../../containers/BillingDriverPay";
import BillingActivitiesList from "./BillingActivitiesList";
import InvoiceContact from "./InvoiceContact";
import TransportationChargesList from "./TransportationChargesList";
import { fetchAccessorialDetails, fetchAccessorialsComponents,fetchAccountAccessorials as fetchAccountComponentAccessorials } from "../../api/Accessorials";
import EditIcon from "../common/EditIcon";
import { AccountUnitsContext } from "../../context/AccountUnitsContext";
import BillingRemarksTabContent from "./BillingRemarksTabContent";
import PaperworkApprovalReasonModal from "./PaperworkApprovalReasonModal";
import { displayWeightUnits } from "../orders/helpers";
import MixedGallery from "../../stories/MixedGallery";
import { handlePrint } from "../../common/preview";
import PdfPreviewViewer from "../../common/PdfPreviewViewer";
import ChargesSection from './ChargesSection';
import '../../../stylesheets/billing-v2.css';
import PrepaidAmountWithPreview from './PrepaidAmountWithPreview';
import { cashReceiptLegsForOrder } from './cashReceiptPreviewUtils';
import AlertModal from "./AlertModal";
import Button_v2 from "../../stories/components/Button_v2";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { confirm } = Modal;

const nextsteps = {
  [I18n.t("invoices.ready_for_billing")]: "APPROVED",
  APPROVED: "PAYMENT_CONFIRMED",
  PAYMENT_CONFIRMED: "CLOSED",
};

const requiredFields = [
  // {
  //   form_field: "invoice_name",
  //   ui_name: I18n.t("invoices.description"),
  //   isRequired: true,
  //   inputType: "text",
  // },
  {
    form_field: "invoice_value",
    ui_name: I18n.t("invoices.amount"),
    isRequired: true,
    inputType: "floatNumber",
  },
];

// Show backend lbs/kgs values as-is (no rounding).
const formatWeightBothUnitsAsIs = (lbs, kgs) => {
  const hasLbs = !isEmpty(lbs) || lbs === 0;
  const hasKgs = !isEmpty(kgs) || kgs === 0;
  if (!hasLbs && !hasKgs) return "N/A";
  const lbsLabel = hasLbs ? `${lbs} lbs` : "";
  const kgsLabel = hasKgs ? `${kgs} kgs` : "";
  return `${lbsLabel}${hasLbs && hasKgs ? " / " : ""}${kgsLabel}`;
};

const ContentOuter = ({ message, navigateToBilling }) => (
  <Spin tip="Fetching Billing Details...">
    <div className="content-outer">
      <div className="content indvOrderScreen">
        <Row >
          <Col md={12}>
            <div>
              <span>
                <span className="breadCrumbLink">{message}</span>
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </Spin>
);

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account:{},
      activeKey: "details",
      invoice: {},
      consolidatedOrderNumbers: null,
      isDriverSettlementApproved: null,
      rawInvoice : {},
      inProgress: false,
      noModifyLoading: false,
      errors: [],
      currentStatus: "",
      disableRemarksButton: true,
      comments: "",
      accessorials: [],
      levelOfServices: [],
      currentLos: "",
      config: {},
      currentOrderPics: {},
      imagesVisible: false,
      logo: null,
      showAddOrders: false,
      showEmailModal: false,
      isEmailLoading: false,
      billingEmails: [],
      contacts: [],
      subject: "",
      description: "",
      isSendingMail: false,
      additionalOrders: "",
      isRemovingGroupOrder: false,
      organizationSettings: {},
      invoiceLos: {},
      isLoading: false,
      isSaving: false,
      ordersAddingProgress: false,
      enableHide: false,
      removeEditingVals: null,
      removeIndvEditingVals: null,
      is_pickup_by_driver: "false",
      pickup_order_driver_id: "",
      pickup_order_amount: null,
      decimalPoints: null,
      isRepproveLoading: false,
      selectedInfo: null,
      showActions: true,
      editForm : false,
      selectedOrderId: "",
      currentOrder: {},
      editForm: false,
      isFetchingDrivers: false,
      technicians: [],
      showGroupOrder: false,
      drivers: [],
      activeRecordId: this.props.activeRecordId,
      isLosChanged: false,
      isInvoiceLocked: false,
      isOnHold: false,
      filter: this.props.filter,
      isApproved: false,
      billingActivitiesList: [],
      filteredBillingActivitiesList: [],
      filteredOrdersForActivities : [],
      filterOrderIds : [],
      defaultTransportationChargeGLCode : "",
      currentGalleryLocId: "",
      configLoading: false,
      currentOrderGroupType: this.props.currentOrderGroupType || "",
      ikeaChargesrecord: [],
      newIkeaChargesRecord:[],
      orgComponents: [],
      displayComponents: [],
      accountComponentAccessorial: [],
      orderAccessorials: [],
      authorizeDetails: {},
      slotConfig:{},
      driversList : [],
      callInProgress : false,
      losConfig: {},
      losProgress: false,
      isEditHawbDate: false,
      isEditMawbDate: false,
      isHawbDatemodified: "",
      currentProcessedId: "",
      editedFuelPercent: "",
      fuelPerUpdateLoading: false,
      isPaperWorkDone: false,
      chargesLinesWarning: "",
      openWarningModal: false,
      // Expanded lines items...
     // In your state
      expandedRowIds: {},  
      expandedChargeLineData: {},
      //...
      openConfirmModal: false,
      description: "",
      confirmModalType: "",
      confirmModalLoading: false,
      approvalReasonModalVisible: false,
      approveInProgress: false,
    };
  }

  isFromPendingBucket = () =>
    ["PAPER_WORK_PENDING", "PENDING"].includes(this.props.filter);

  isIndividualStopLosOrderLevel = _.get(this.props, 'organizationSettings.individual_stop_los_order_level', '') == "true";
  
  addBilligEmail = (value) => {
    const validEmails = validateEmailList(value);
    this.setState({ billingEmails: validEmails });
  };


  getTechnicians = () => {
    fetchTechnicians().then((result) => {
      if (result.success) {
        const technicians = result.users || [];
        this.setState(
          {
            technicians,
          }
        );
      } else {
        this.setState({ technicians: [] });
      }
    });
  };

  getDrivers = () => {
    const orgId = this.props.userContext?.currentOrg?.id || '';
    this.setState({ isFetchingDrivers: true });

    fetchDriverList({ unscoped: true, orgId , includeWH: true})
    .then((result) => {
      if (result.success && result?.data?.drivers) {
        const orgDrivers = result.data.drivers || [];

        const allDrivers = orgDrivers.map(driver => ({
          id: driver.id,
          employee_code: driver.employee_code,
          full_name: formatFullName(driver),
          deleted_at: driver.deleted_at,
          first_name: driver.first_name,
          last_name: driver.last_name,
        }));

        this.setState({
          drivers: [...allDrivers], //allDrivers.filter(driver => !driver.deleted_at),
          driversList: [...allDrivers],
        });
      } else if (result.errors) {
        renderAlertMessage(result.errors);
        this.setState({ drivers: [], driversList: [] });
      }
    })
    .catch((error) => {
      alertMessage(error.message, 'error', 10);
      this.setState({ drivers: [], driversList: [] });
    })
    .finally(() => {
      this.setState({ isFetchingDrivers: false });
    });
  };

  getCompleteDrivers = () => {
    // this.setState({inProgress : true})
    // fetchUsers("driver",
    //   1,
    //   null,
    //   "none",
    //   "ascend",
    //   false,
    //   "",
    //   false,
    //   null,
    //   "",
    //   "",
    //   true
    // ).then((result) => {
    //   if(result.success){
    //     const updatedDrivers = result.users.map((driver) => ({
    //       id: driver.id,
    //       employee_code: driver.employee_code,
    //       full_name: driver.full_name,
    //     }));
    //     this.setState({driversList : updatedDrivers});
    //   } else {
    //     renderAlertMessage(result.errors)
    //   }
    // }).catch((error) => {
    //   alertMessage(error.message, "error",10)
    // }).finally(() => {
    //   this.setState({inProgress : false})
    // });
  };

  handleInvoiceResponse = (result, id) => {
    const defaultInvoice = {
      description: {},
      account_details: {},
      customer_details: {},
      customer_order_id: id,
      remarks: _.get(result, 'remarks', []),
      consolidated_order_numbers: _.get(result, 'consolidated_order_numbers', []),
      is_driver_settlement_approved: result.is_driver_settlement_approved,
      pickup_driver_pay_details: result.pickup_driver_pay_details || {},
      accessorial_charges: [],
      adjustment_charges: [],
      transportation_charges: [],
      order_info: {},
      status: result.billing_status,
      error_log: [],
      error_messages: [],
    };

    const currentInvoice = _.merge({}, defaultInvoice, result.invoice);

    const error_logs = result.error_logs || [];
    currentInvoice.error_log = _.map(_.filter(error_logs, 'error_log'), 'error_log');
    currentInvoice.error_messages = _.map(_.filter(error_logs, 'error_message'), 'error_message');
    // group_orders is a top-level response key (sibling of invoice), not nested
    // inside result.invoice — copy it so the estimate FMP/SMP popover can read it.
    currentInvoice.group_orders = _.get(result, 'group_orders', []);

    return currentInvoice;
  };


  sortPriceList = (data) => {
    const sortedData = _.cloneDeep(data);

    // Sort accessorial charges
    sortedData.accessorial_charges.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    // Sort transportation charges
    // sortedData.transportation_charges.forEach(charge => {
    //   charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    // });

    // Sort fuel surcharges
    sortedData?.fuel_surcharges?.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    // Sort adjustment charges
    sortedData.adjustment_charges.forEach(charge => {
      charge.price_list = _.sortBy(charge.price_list, 'invoice_name');
    });

    return sortedData;
  };


  onHawbDateChange = (date, dateString) => {
    // if not valid date, return
    if(!moment(dateString, "MMM D").isValid()) {
      return;
    }
    const jsDate = new Date(dateString);
    const month = String(jsDate.getMonth() + 1).padStart(2, '0');
    const day = String(jsDate.getDate()).padStart(2, '0');
    const formattedDate = `${month}.${day}`;
    this.setState({ isHawbDatemodified: formattedDate });
  }

  saveHawbDateChange = () => {
    if (!_.isEmpty(this.state.isHawbDatemodified) || !_.isEmpty(this.state.editableHawb)) {
      const current_org = _.get(this.props, 'userContext.currentOrg', '');

      const payload = {
        organization_id: current_org.id,
        customer_order_id: this.state.invoice.customer_order_id,
        hawb: this.state.editableHawb
      };

      if (this.state.isHawbDatemodified) {
        payload.hawb = `${payload.hawb} ${this.state.isHawbDatemodified}`;
      }

      saveHawbChangedDate(payload).then((res) => {
        if (res.success) {
          this.setState({
            invoice: {
              ...this.state.invoice,
              transportation_charges: [ {
                ...this.state.invoice.transportation_charges[ 0 ],
                hawb: payload.hawb
              } ]
            },
            isEditHawbDate: false,
            isHawbDatemodified: "",
            editableHawb: ""
          });
          message.success("Hawb updated successfully");
        } else {
          message.error("Failed to update Hawb");
        }
      });
    } else {
      return message.error('No changes made to Hawb');
    }
  }

  saveMawbDateChange = () => {
    if (!_.isEmpty(this.state.editableMawb)) {
      const current_org = _.get(this.props, 'userContext.currentOrg', '');

      const payload = {
        organization_id: current_org.id,
        customer_order_id: this.state.invoice.customer_order_id,
        mawb: this.state.editableMawb
      };

      saveHawbChangedDate(payload).then((res) => {
        if (res.success) {
          this.setState({
            invoice: {
              ...this.state.invoice,
              transportation_charges: [{
                ...this.state.invoice.transportation_charges[0],
                mawb: payload.mawb
              }]
            },
            isEditMawbDate: false,
            editableMawb: ""
          });
          message.success("Hawb updated successfully");
        } else {
          message.error("Failed to update Hawb");
        }
      });
    } else {
      return message.error('No changes made to Hawb');
    }
  }

  handleUpdateInvoice = (updatedInvoice, orderNo) => {
    this.setState(prevState => {
      // Update the state with new invoice data
      const updatedOrderDriverDetails = prevState.invoice.order_driver_details.map(order => {
        if (order.customer_order_id === orderNo) {
          return {
            ...order,
            driver_details: updatedInvoice.order_driver_details.find(o => o.customer_order_id === orderNo)?.driver_details || [],
          };
        }
        return order;
      });
  
      return {
        invoice: {
          ...prevState.invoice,
          order_driver_details: updatedOrderDriverDetails,
        },
      };
    });
  };

  renderHawbDatePicker = () => {
    return (
      <Row type="flex" gutter={5}>
        <Col>
          <DatePicker
            size="small"
            format={"MMM D"}
            onChange={this.onHawbDateChange}
            style={ { width: '120px' } }
            allowClear={ false }
            autoFocus
          />
        </Col>
        <Col>
          <Icon type="save" theme="twoTone" className="fontSize14 cusorPointer" 
            onClick={() => this.saveHawbDateChange()}
          />
        </Col>
        <Col>
          <Icon type="close" className="fontSize14 cusorPointer" 
            onClick={() => this.closeHawbDatePicker()}
          />
        </Col>
      </Row>
    )
  }

  closeHawbDatePicker = () => {
    this.setState({
      isEditHawbDate: false,
      isHawbDatemodified: "",
      editableHawb: ""
    });
  }

  closeMawbDatePicker = () => {
    this.setState({
      isEditMawbDate: false,
      editableMawb: ""
    });
  }

  handleEditHawbDate = (val) => {
    const trimmedHawb = this.trimDateFromHawb(this.state.invoice.transportation_charges[ 0 ].hawb);
    this.setState({
      isEditHawbDate: val,
      editableHawb: trimmedHawb
    });
  }

  handleEditMawbDate = (val) => {
    this.setState({
      isEditMawbDate: val,
      editableMawb: this.state.invoice.transportation_charges[0].mawb
    });
  }


  getBillingDetails = (id) => {
    this.setState({ isLoading: true });
    const currentOrderGroupType = this.state.currentOrderGroupType || this.state.invoice.order_group_type || "";
    // Estimate tab displays the QUOTE (order_quotation_invoice_details), not the
    // billing invoice. Normalize the quote response to the billing-details shape
    // this method expects (billing_status drives showActions so inline edit works).
    const detailsPromise = this.props.fromEstimate
      ? fetchQuotationDetails(id, this.estimateApiParams()).then((res) => ({
          ...res,
          billing_status: _.get(res, "invoice.status") || "READY_FOR_BILLING",
          billing_check_lists: res.billing_check_lists || {},
        }))
      : fetchBillingDetails(id, currentOrderGroupType);
    detailsPromise.then((result) => {
      if (result.success) {
        const invoiceStatus = result.billing_status;
        const billing_check_lists = result.billing_check_lists;
        const orgCode = _.get(this.props, 'userContext.currentOrg.code', '');
        const showHoldBucket = _.get(this.props, 'organizationSettings.show_hold_bucket', '') == "true" && checkServiceExistance("FBLOS");
        const showPendingBucket = _.get(this.props, 'organizationSettings.show_pending_bucket', '') == "true" && checkServiceExistance("SPB");
        let currentInvoice = this.handleInvoiceResponse(result, id);
        currentInvoice = this.sortPriceList(currentInvoice);
        const defaultTransportationChargeGLCode = result.invoice.transportation_gl_code;
        const transportationCharges = currentInvoice?.transportation_charges?.length ? currentInvoice.transportation_charges[0] : []
        const checkPaperWorkDone = billing_check_lists?.paper_work_done ? billing_check_lists.paper_work_done : "false"
        const billingLogoUrl = currentInvoice?.warehouse_details?.billing_logo_url || "";
        this.setState(
          {
            invoice: currentInvoice,
            inProgress: false,
            consolidatedOrderNumbers: currentInvoice.consolidated_order_numbers,
            isDriverSettlementApproved: currentInvoice.is_driver_settlement_approved,
            is_pickup_by_driver: _.get(currentInvoice, 'pickup_driver_pay_details.is_pickup_by_driver', "false"),
            pickup_order_driver_id: _.get(currentInvoice, 'pickup_driver_pay_details.pickup_order_driver_id', ""),
            pickup_order_amount: _.get(currentInvoice, 'pickup_driver_pay_details.pickup_order_amount', null),
            decimalPoints: window.localStorage.getItem('round_off_decimals'),
            isLoading: false,
            organizationSettings: this.props.organizationSettings,
            showActions: (currentInvoice.status === 'READY_FOR_BILLING' || this.isFromPendingBucket()) && (this.props.callFrom !== "order" || checkAccessExistance("BILLING_FROM_ORDER")),
            isInvoiceLocked: currentInvoice?.transportation_charges &&
              currentInvoice.transportation_charges.filter(rec => rec.is_locked == 'true').length > 0 ? true : false,
            isOnHold: showHoldBucket ? invoiceStatus == 'HOLD' : false,
            defaultTransportationChargeGLCode: defaultTransportationChargeGLCode, // Set default GL code
            // ikeaChargesrecord: transportationCharges?.price_list?.length ? transportationCharges.price_list : []
            ikeaChargesrecord:
              this.state.newIkeaChargesRecord?.length > 0
                ? [
                    ...(transportationCharges?.price_list || []),
                    ...this.state.newIkeaChargesRecord,
                  ]
                : transportationCharges?.price_list || [],
            logo: billingLogoUrl,
            isPaperWorkDone: checkPaperWorkDone === "true"
          },
          () => {
            // if (modalElemet) {
            //   this.handleOnChange(modalElemet, true);
            // }
            this.setState({rawInvoice: currentInvoice})
            if(Object.keys(this.state.rawInvoice).length === 0){
              // this.setState({rawInvoice: currentInvoice})
              this.getDrivers();
              //this.getCompleteDrivers();
              this.getAccessorials();
              this.getAccountLos();
              this.setAccountLos();
              this.getAccountConfigs();
              // this.getOrgLogo();
              this.setInvoiceLos();
              this.setSelectedInfo();
              this.getTechnicians();

              if (isEmpty(billingLogoUrl)) {
                this.getOrgLogo();
              }
            } else{
              this.setInvoiceLos()
            }
            // Notify the parent (e.g. the order-screen Estimate tab) so its own
            // billing summary refreshes after loads/saves. Guarded: the billing
            // manage screen does not pass getInvoices, so it is a no-op there.
            if (typeof this.props.getInvoices === "function") {
              this.props.getInvoices(
                currentInvoice.customer_order_id,
                currentInvoice.total_amount
              );
            }
          }
        );
      } else {
        renderAlertMessage(result.errors);
        this.setState({
          invoice: {},
          isLoading: false,
        });
      }
    });
  };

  // getOrgComponents = () => {
  //   fetchAccessorialsComponents().then((result) =>{
  //     if(result.success){
  //       const orgComponentsResponse = result.components || [];
  //       const displayComponents = [];
  //       const noParamComponents = [];
  //       orgComponentsResponse.forEach((component) => {
  //         if (
  //           component.component_params &&
  //           component.component_params.length > 0
  //         ) {
  //           const componentParams = component.component_params || [];
  //           const visibleParams = componentParams.filter((param) =>
  //             param.visible_to.includes('DISPATCHER'),
  //           );
  //           if (visibleParams.length > 0) {
  //             displayComponents.push(component.code);
  //           } else {
  //             noParamComponents.push(component.code);
  //           }
  //         } else {
  //           noParamComponents.push(component.code);
  //         }
  //       });
  //       this.setState({orgComponents : orgComponentsResponse,displayComponents :displayComponents })
  //     }
  //   }).finally(() => {
  //     this.getAccountComponentAccessorials();
  //   })
  // }

  // getSlotDetails = (id, reqCode = '') => {
  //   this.getAccessorialDetails(id, reqCode);
  // };

  // getAccessorialDetails = (id, reqCode) => {
  //   fetchAccessorialDetails(id).then((result) => {
  //     if (result.success) {
  //       const currentAccessorial = result.accessorial || [];
  //       const componentParams = currentAccessorial ? currentAccessorial.component_params : [];
  //       const slotParams = !isEmpty(reqCode) ?
  //         componentParams.filter(param => param.component_code === reqCode) :
  //         [ ...componentParams ];
  //       const newSlotConfig = { ...this.state.slotConfig };
  //       newSlotConfig[ id ] = slotParams;
  //       this.setState({slotConfig : newSlotConfig})
  //     } else {
  //       const newSlotConfig = { ...this.state.slotConfig };
  //       newSlotConfig[ id ] = [];
  //       renderAlertMessage(result.errors);
  //       setInProgress(false);
  //       this.setState({slotConfig : newSlotConfig})
  //     }
  //   });
  // };


  // getAccountComponentAccessorials = () => {
  //   const invoice = this.initialChargeValues(this.state.invoice);
  //   const accountId = _.get(invoice, "account_details.id", null);
  //   const orgId = _.get(this.props.userContext,"currentOrg.id",null)
  //   if(accountId) {
  //     this.setState({callInProgress : true})
  //     fetchAccountComponentAccessorials(orgId, accountId, "DISPATCHER").then((result) => {
  //       if(result.success) {
  //         const accessorials = result.accessorials || [];
  //         const accountComponentAccessorial = accessorials.map(
  //           (accessorial) => {
  //             const componentDefs = this.getDefinitions(accessorial);
  //             const slotObject = _.find(componentDefs, { code: 'SLOTS' });
  //             if (!isEmpty(slotObject)) {
  //               this.getSlotDetails(accessorial.id, 'SLOTS');
  //             }
  //             return Object.assign({}, accessorial, {
  //               componentDefs,
  //             });
  //           },
  //         );
  //         this.setState({callInProgress : false})
  //         const sortedAccountComponentAccessorial = _.sortBy(accountComponentAccessorial, [ "standard_code", "accessorial_code" ]);
  //         this.setState({accountComponentAccessorial : sortedAccountComponentAccessorial})
  //       }
  //     }).finally(() => {
  //       this.getOrderAccessorials(); 
  //     })
  //   }
  // };

  // getDefinitions = (accessorial) => {
  //   if (!isEmpty(accessorial)) {
  //     const components = accessorial.components || [];
  //     const accComponents = components.map(
  //       (component) => component.component_code,
  //     );
  //     const componentDefs = this.state.orgComponents.filter(
  //       (component) =>
  //         accComponents.includes(component.code) &&
  //         this.state.displayComponents.includes(component.code),
  //     );
  //     return componentDefs;
  //   }
  //   return [];
  // }

  // getOrderAccessorials = () => {
  //   fetchOrderAccessorials(this.state.activeRecordId, "").then((result) => {
  //     if (result.success) {
  //       const orderAccessorial = result.accessorials || {};
  //       const accessorials = orderAccessorial.account_accessorial_params || [];
  //       const authorizeDetails = {};
  //       const allowedIds = {};
  //       this.state.accountComponentAccessorial.forEach(
  //         (accessorial) => {
  //           const components = accessorial.components ?
  //             accessorial.components.map(record => record.component_code)
  //             :
  //             [];
  //           allowedIds[ accessorial.id ] = [ ...components ];
  //         });
  //       const orderAccessorials = setAccessorialResponse(
  //         accessorials,
  //         true,
  //         allowedIds,
  //       );
  //       orderAccessorials.forEach(rec => {
  //         if (!isEmpty(rec.authorized_by)) {
  //           authorizeDetails[ rec.accessorial_code ] = {
  //             authorized_by: rec.authorized_by,
  //             authorization_code: rec.authorization_code,
  //             comments: rec.comments,
  //             is_modified: false,
  //           };
  //         }
  //       });
  //       this.setState({orderAccessorials : orderAccessorials, authorizeDetails : authorizeDetails})
  //     } else {
  //       renderAlertMessage(result.errors);
  //     }
  //   })
  // }

  // /when unmounting send the order numbers in this invoice to parent
  componentWillUnmount() {
    if (this?.props?.callFrom === "order") { // stopping to call index while cancelling modal from order screen. 
      return;
    }
    const transportation_charges = _.get(this.state, "invoice.transportation_charges", []) || []
    const orderNumbers = transportation_charges.map(
      (order) => order.order_number
    );
    if(this.props.onUnmount)
      this.props.onUnmount(orderNumbers, this.state.isApproved);
  }

  componentDidMount () {
    const {activeRecordId}=this.state;
    this.getBillingDetails(activeRecordId);
    // this.getOrgComponents();
  }
  
  setSelectedInfo = () => {
    let totalOrders = this.getInvoiceOrders();
    const selectedInfo = {
      selectedKeys: totalOrders.map((order) => order.order_id),
      selectedRows: [...totalOrders],
    };
    this.setState({ selectedInfo });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(
        prevState.organizationSettings,
        this.props.organizationSettings
      )
    ) {
      this.setState({
        organizationSettings: this.props.organizationSettings,
      });
    }

    // on change if invoice is changed, update current order pics
    if (
    !_.isEqual(prevProps.currentInvoice, this.props.currentInvoice) || 
    !_.isEqual(prevState.invoice, this.state.invoice) && this.state.currentGalleryLocId)
      this.imageAction(this.state.currentGalleryLocId);

      // if(!_.isEqual(prevState.orgComponents, this.state.orgComponents)){
      //   this.getAccountComponentAccessorials();
      // }
  }

  getOrgLogo = () => {
    const orgId = userStore.getStateValue("selectedOrg");
    fetchOrganizationDetails(orgId).then((result) => {
      if (result.success) {
        const organization = result.organization || {};
        organization.logo =
          !isEmpty(organization.logo) && organization.logo.url
            ? organization.logo.url
            : "";

        if (organization.logo) {
          this.setState({
            logo: organization.logo,
          });
        } else if (!isEmpty(orgId)) {
          const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
          fetch(urlToFile).then((response) => {
            if (response.status === 200) {
              this.setState({
                logo: urlToFile,
              });
            }
          });
        }
      }
    });
    // const orgId = userStore.getStateValue("selectedOrg");
    // if (!isEmpty(orgId)) {
    //   const urlToFile = `${AppConfig.baseUrl}/org_logos/${orgId}/org_logo.png`;
    //   fetch(urlToFile)
    //     .then(response => {
    //       if (response.status === 200) {
    //         this.setState({
    //           logo: urlToFile
    //         })
    //       }
    //     });
    // }
  };

  setAccountLos = () => {
    const los =
      this.state.invoice.order_info &&
      this.state.invoice.order_info.level_of_service
        ? this.state.invoice.order_info.level_of_service
        : "";
    this.handleStateOnChange("currentLos", los);
  };

  getAccessorials = () => {
    const orgId = userStore.getStateValue("selectedOrg");
    const account = this.state.invoice.account_details
      ? this.state.invoice.account_details
      : {};
    fetchAccountComponentAccessorials(orgId, account?.id, "DISPATCHER").then((result) => {
      if (result.success) {
        this.setState({
          accessorials: result.accessorials,
          inProgress: false,
        });
      } else {
        renderAlertMessage(result.errors)
        this.setState({ inProgress: false });
      }
    });
  };

  getAccountLos = async () => {
    const { invoice } = this.state;
    const { userContext } = this.props;
    const accountObj = invoice?.account_details || {};
    const accountCode = accountObj.code || '';
    const accountId = accountObj.id || '';
    const currentOrgId = userContext?.currentOrg?.id || '';
    this.setState({
      losProgress: true,
    })
    try {
        const [losResponse, configResponse] = await Promise.all([
            fetchAccountShortLos(accountCode),
            fetchOrderTypeLos(currentOrgId, accountId),
        ]);
        const losConfig = configResponse?.success ? 
        configResponse.data.los.reduce((acc, rec) => {
            acc[rec.order_type] = rec.los_codes ? [...rec.los_codes, 'NONE'] : ['NONE'];
            return acc;
        }, {}) : {};

        if (losResponse.success) {
            const levelOfServices = losResponse.account.account_los || [];
            this.setState({
                losConfig,
                levelOfServices: [
                    ...levelOfServices,
                    {
                        name: "None",
                        code: "NONE",
                        duration: "0",
                        id: "NONE",
                    },
                ],
                losProgress: false
            });
        } else {
            renderAlertMessage(losResponse.errors);
            this.setState({ losProgress: false, losConfig });
        }
    } catch (error) {
        console.error(`Error fetching ${I18n.t('general.short_los')}:`, error);
        this.setState({ losProgress: false, losConfig: {} });
    }
};

  getEmails = () => {
    const account = this.state.invoice.account_details
      ? this.state.invoice.account_details
      : {};
    const accountId = account.id ? account.id : ""
    this.setState({ isEmailLoading: true })
    getContactEmails(accountId).then((result) => {
      if (result.success) {
        this.setState({
          contacts: result.contact_emails || [],
          isEmailLoading: false
        })
      }else{
        renderAlertMessage(result.errors)
        this.setState({ isEmailLoading: false, contacts: [] });
      }
    })
  }

  findPriceTotal = () => {
    const { invoice } = this.state;
    let totalAmount = 0;
    let consideredCharges = []
    if (this.state.currentOrderGroupType === "TEMPLATE"){
      consideredCharges = ["transportation_charges"];
    }else{
      consideredCharges = [
        "transportation_charges",
        "fuel_surcharges",
        "accessorial_charges",
        "adjustment_charges",
      ];
    }
    consideredCharges.forEach((descriptionEle) => {
      const priceList = invoice[descriptionEle].map(
        (order) => order.price_list
      );
      const flattenList = _.flatten(priceList);
      const amount = parseFloat(findTotal(flattenList, "invoice_value"));
      totalAmount += amount;
    });
    this.handleOnChange("total_amount", totalAmount);
  };


  findIndvPriceTotal = () => {
    const { invoice } = this.state;
    let totalAmount = 0;
    let consideredCharges = []
    if (this.state.currentOrderGroupType === "TEMPLATE"){
      consideredCharges = ["transportation_charges"];
    }else{
      consideredCharges = [
        "transportation_charges",
        "fuel_surcharges",
        "adjustment_charges",
      ];
    }
    consideredCharges.forEach((descriptionEle) => {
      const indvList = invoice[descriptionEle].map(
        (order) => order.individual_lines
      );
      const flattenList = _.flatten(indvList);
      const amount = parseFloat(findTotal(flattenList, "invoice_value"));
      totalAmount += amount;
    });
    this.handleOnChange("total_amount", totalAmount);
  };

  findSectionTotal = (sectionType, orderNo) => {
    const { invoice, ikeaChargesrecord } = this.state;
    const charges = [...invoice[sectionType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const priceList =
        this.state.currentOrderGroupType === "TEMPLATE"
          ? ikeaChargesrecord
          : !isEmpty(charges[elementIndex].price_list)
          ? charges[elementIndex].price_list
          : [];
      // const flattenList = _.flatten(priceList);
      const amount = findTotal(priceList, "invoice_value", 1, true);
      return amount;
    }
    return 0.0;
  };

    findIndvSectionTotal = (sectionType, orderNo) => {
    const { invoice, ikeaChargesrecord } = this.state;
    const charges = [...invoice[sectionType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const indvPriceList =
        this.state.currentOrderGroupType === "TEMPLATE"
          ? ikeaChargesrecord
          : !isEmpty(charges[elementIndex].individual_lines)
          ? charges[elementIndex].individual_lines
          : [];
      // const flattenList = _.flatten(indvPriceList);
      const amount = findTotal(indvPriceList, "invoice_value", 1, true);
      return amount;
    }
    return 0.0;
  };


  handleOnChange = (element, value, cb = null) => {
    this.setState(
      {
        invoice: Object.assign({}, this.state.invoice, { [element]: value }),
      },
      cb
    )
  };

  getLocationPoolForChargeItem = (itemType, orderNo) => {
    const charges = this.state.invoice[itemType] || [];
    const section = _.find(charges, { order_number: orderNo });
    if (!section?.order_id) return [];
    const orderRow = _.find(this.getInvoiceOrders(), { order_id: section.order_id });
    if (!orderRow) return [];
    const locations = orderRow.locations || [];
    const allLocations = orderRow.all_locations || [];
    let pool =
      ["transportation_charges", "fuel_surcharges", "adjustment_charges"].includes(
        itemType
      ) && allLocations.length
        ? allLocations
        : locations;
    pool = [...pool];
    const ordersInfo = this.state.invoice.orders_info || [];
    ordersInfo.forEach((info) => {
      (info.locations || []).forEach((loc) => {
        if (!loc?.location_id) return;
        if (_.some(pool, (p) => p.location_id === loc.location_id)) return;
        const segType = info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY";
        pool.push({
          location_id: loc.location_id,
          order_type: segType,
        });
      });
    });
    return pool;
  };

  resolveLocationTypeForLocationId = (locationId, locations = []) => {
    if (isEmpty(locationId) || !locations?.length) return "";
    const loc = _.find(locations, (l) => l.location_id === locationId);
    if (!loc) return "";
    return (
      loc.order_type ||
      loc.location_type ||
      loc.type_of_loc ||
      loc.segment_type ||
      ""
    );
  };

  enrichInvoiceLineForSave = (line, itemType, orderNo, rawPriceList) => {
    const originalLine = _.find(rawPriceList, { id: line.id });
    const old_location_id = originalLine ? originalLine.location_id : line.location_id;
    const old_location_type = originalLine
      ? (originalLine.location_type ?? "")
      : (line.location_type ?? "");
    const pool = this.getLocationPoolForChargeItem(itemType, orderNo);
    const location_type =
      this.resolveLocationTypeForLocationId(line.location_id, pool) ||
      (line.location_type ?? "");
    return {
      ...line,
      location_id: line.location_id,
      location_type,
      old_location_id,
      old_location_type,
    };
  };

  editSave = (index, itemType, orderNo, id) => {
    this.setState({  isSaving: true });
    let newInvoiceLines = [];
    const { invoice,selectedInfo } = this.state;
    const {currentOrg} = this.props.userContext
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    const typeObject = invoice[itemType][elementIndex] || {};
    const priceList = typeObject.price_list || [];

    const invoiceLines = priceList.filter((line) => line.isEditing === true);
    // Get raw price list for original location lookup
    const rawCharges = [...this.state.rawInvoice[itemType]];
    const rawElementIndex = _.findIndex(rawCharges, { order_number: orderNo });
    const rawPriceList = rawElementIndex >= 0
      ? (rawCharges[rawElementIndex].price_list || [])
      : [];


    const accessorialNames = this.state.accessorials.map(accessorial => 
      accessorial.accessorial_name.trim().toLowerCase()
    );    
    const hasMatchingName = invoiceLines.some(line => 
      accessorialNames.includes(line.invoice_name.trim().toLowerCase())
    );  
    // if (hasMatchingName) {
    //   this.setState({ isSaving: false });
    //   return;
    // } 

      newInvoiceLines = invoiceLines.map((line) => {
      const enriched = this.enrichInvoiceLineForSave(line, itemType, orderNo, rawPriceList);
      return {
        ...enriched,
        invoice_type: I18n.t(`invoices.invoice_types.${itemType}`),
      };
    });

    const orderInfo = invoice.order_info || {};
    const data = {
      invoice_line_id: id,
      new_invoice_lines: newInvoiceLines,
      remark: "",
      order_group_type: invoice.order_group_type,
      customer_order_id: typeObject.order_id || orderInfo.order_id || "",
      reference_id:
        invoice.order_group_type === "ORDER"
          ? invoice.customer_order_id
          : invoice.order_number,
      status: invoice.status,
      ...this.estimateApiParams(),
    };
    const selectedIds = selectedInfo?.selectedKeys
    ? _.compact(selectedInfo.selectedKeys)
    : []

    const reApprovalBilling = {
      customer_order_ids: selectedIds,
      organization_id: _.get(currentOrg, "id", ""),
      invoice_number: _.get(invoice, "order_number", ""),
    }

    const reApproveCall = () => reapproveBillings(reApprovalBilling);

    updateInvoiceCharges(data).then((result) => {
      if (result.success) {
        alertMessage(I18n.t("messages.saved"));
        // udpate in the state
        let updatedOrder = _.cloneDeep(invoice[itemType]);
        // replace the old invoice lines with the new ones and turn off editing
        updatedOrder[elementIndex].price_list = updatedOrder[elementIndex].price_list.map((item) =>
        {
          if(item.isEditing){
            return {
              ...item,
              ...newInvoiceLines.find((line) => line.id === item.id),
              isEditing: false,
            }
          }
          return item
        });

        // this.handleOnChange(itemType, updatedOrder, () => {
        //   this.findPriceTotal();
        // });

        this.setState(
          {
            invoice: {
              ...invoice,
              [itemType]: updatedOrder,
            },
            inProgress: false,
            isSaving: false,
          },
          () => {
            this.findPriceTotal();
            this.getBillingDetails(this.state.invoice.customer_order_id);
            // this.cancelEditItem(index, itemType,id);
            if(invoice.status === "APPROVED"){
              reApproveCall();
            }
          }
        );
      } else {
        alertMessage(result.errors, "error", 10);
        this.setState({ inProgress: false, isSaving: false });
      }
    });
  };

clearExpandedRowsByType = (itemType) => {
  this.setState((prevState) => ({
    expandedRowIds: {
      ...prevState.expandedRowIds,
      [itemType]: '',
    },
    expandedChargeLineData: {
      ...prevState.expandedChargeLineData,
      [itemType]: [],
    },
  }));
};

  
   editIndvSave = (index, itemType, orderNo, id) => {
    this.setState({  isSaving: true });
    let newInvoiceLines = [];
    const { invoice,selectedInfo } = this.state;
    const {currentOrg} = this.props.userContext
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    const typeObject = invoice[itemType][elementIndex] || {};
    const indvList = typeObject.individual_lines || [];
    const invoiceLines = indvList.filter((line) => line.isEditing === true);
    const accessorialNames = this.state.accessorials.map(accessorial => 
      accessorial.accessorial_name.trim().toLowerCase()
    );    
    const hasMatchingName = invoiceLines.some(line => 
      accessorialNames.includes(line.invoice_name.trim().toLowerCase())
    );  
    // if (hasMatchingName) {
    //   this.setState({ isSaving: false });
    //   return;
    // } 


    // Get raw individual_lines for original location lookup
    const rawCharges = [...this.state.rawInvoice[itemType]];
    const rawElementIndex = _.findIndex(rawCharges, { order_number: orderNo });
    const rawIndvList = rawElementIndex >= 0
      ? (rawCharges[rawElementIndex].individual_lines || [])
      : [];

    newInvoiceLines = invoiceLines.map((line) => {
      const enriched = this.enrichInvoiceLineForSave(line, itemType, orderNo, rawIndvList);
      return {
        ...enriched,
        invoice_type: I18n.t(`invoices.invoice_types.${itemType}`),
      };
    });
    const orderInfo = invoice.order_info || {};
    const data = {
      invoice_line_id: id,
      new_invoice_lines: newInvoiceLines,
      remark: "",
      order_group_type: invoice.order_group_type,
      customer_order_id: typeObject.order_id || orderInfo.order_id || "",
      reference_id:
        invoice.order_group_type === "ORDER"
          ? invoice.customer_order_id
          : invoice.order_number,
      status: invoice.status,
      ...this.estimateApiParams(),
    };
    const selectedIds = selectedInfo?.selectedKeys
    ? _.compact(selectedInfo.selectedKeys)
    : []

    const reApprovalBilling = {
      customer_order_ids: selectedIds,
      organization_id: _.get(currentOrg, "id", ""),
      invoice_number: _.get(invoice, "order_number", ""),
    }

    const reApproveCall = () => reapproveBillings(reApprovalBilling);

    updateInvoiceCharges(data).then((result) => {
      if (result.success) {
       this.clearExpandedRowsByType(itemType);      
         alertMessage(I18n.t("messages.saved"));
        // udpate in the state
        let updatedOrder = _.cloneDeep(invoice[itemType]);
        // replace the old invoice lines with the new ones and turn off editing
        updatedOrder[elementIndex].individual_lines = updatedOrder[elementIndex].individual_lines.map((item) =>
        {
          if(item.isEditing){
            return {
              ...item,
              ...newInvoiceLines.find((line) => line.id === item.id),
              isEditing: false,
            }
          }
          return item
        });

        // this.handleOnChange(itemType, updatedOrder, () => {
        //   this.findPriceTotal();
        // });

        this.setState(
          {
            invoice: {
              ...invoice,
              [itemType]: updatedOrder,
            },
            inProgress: false,
            isSaving: false,
          },
          () => {
            this.findIndvPriceTotal();
            this.getBillingDetails(this.state.invoice.customer_order_id);
            // this.cancelEditItem(index, itemType,id);
            if(invoice.status === "APPROVED"){
              reApproveCall();
            }
          }
        );
      } else {
        alertMessage(result.errors, "error", 10);
        this.setState({ inProgress: false, isSaving: false });
      }
    });
  };

  fuelPercentEdit = (record) => {
    const { item_description } = record
    const match = item_description.match(/[\d.]+/);
    const percentVal = match ? match[0] : "";
    this.setState({
      currentProcessedId: record.id,
      editedFuelPercent: percentVal,
    });
  }

  fuelPercentSave = (record) =>{
    const { editedFuelPercent } = this.state;
    const { item_description } = record
    const match = item_description.match(/[\d.]+/);
    const percentVal = match ? match[0] : "";
    if(editedFuelPercent < 0){
      return alertMessage("Please Enter Positive value.", "error", 10);
    }
    if (!isEmpty(editedFuelPercent)) {
      
      const data = {
        organization_id: userStore.getStateValue("selectedOrg"),
        customer_order_id: this.state.invoice.customer_order_id,
        segment_location_id: record.location_id || "",
        invoice_line_id: record.id,
        fuel_percentage_value: editedFuelPercent,
        ...this.estimateApiParams(),
      };

      if (data.fuel_percentage_value !== percentVal) {
        this.setState({ fuelPerUpdateLoading: true });
        updateFuelPercentage(data).then((result) => {
          if (result.success) {
            alertMessage(result.message, "success", 10);
            this.setState({
              currentProcessedId: "",
              editedFuelPercent: "",
              fuelPerUpdateLoading: false,
            },()=>{
              this.refreshDetails()
            });
          } else {
            alertMessage(result.errors, "error", 10);
            this.setState({
              fuelPerUpdateLoading: false,
              currentProcessedId: "",
              editedFuelPercent: "",
            });
          }
        });
      } else {
        this.setState({
          currentProcessedId: "",
          editedFuelPercent: "",
        });
      }
    } else {
      alertMessage("Please Enter Percent value.", "error", 10);
    }
  }

  onFuelPercentChange = (element, value) =>{
    this.setState({
      [element]: value,
    });
  }

  fuelPercentCancel = (id) =>{
    this.setState({
      currentProcessedId: null,
      editedFuelPercent: "",
    });
  }

  handleKeyDown = (record, e) => {
    if (e.key === "Enter") {
      this.fuelPercentSave(record);
    }
  };


  handleStateOnChange = (element, value, isLosChanged = false) => {
    if (this.state.invoice.status == "APPROVED") {
      if (element == "invoiceLos" && isLosChanged ) { //&& val !== retrivedLos)
        this.props.handleIsLosChanged(true);
      } else {
        this.props.handleIsLosChanged(false);
      }
    }
    if (element === "invoiceLos") {
      this.setState({
        [ element ]: value,
      }, () => {
        if(this.state.invoice.status !== "APPROVED"){
          this.reGenerate();
        }
      });
    } else {
      this.setState({
        [ element ]: value,
      });
    }
  };
  handleLosChange = (order_id, index, location_id,  value, oldValue) => {
    if(isEmpty(value)){
      renderAlertMessage(`Please select ${I18n.t('general.level_of_service')}`, 'error', 15)
      return;
    }
    const retrivedLos = this.state?.selectedInfo?.selectedRows[ 0 ]?.level_of_service;
    const val = value ? Object.values(value)[ 0 ] : '';
    const invoiceLos = {...this.state.invoiceLos}
    invoiceLos[order_id][index].level_of_service_code = value
    const isLosChanged  = value !== oldValue;
    this.handleStateOnChange("invoiceLos", invoiceLos, isLosChanged)
  };

  handleItemsChange = (recordNO, element, value, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const index = _.findIndex(charges, { order_number: orderNo });
    if (element === "accessorial_code") {
      this.handleAccessorailChange(recordNO, element, value, itemType, orderNo);
    } else {
      if ((index >= 0 && charges[ index ].price_list[ recordNO ].isNew) || (index >= 0 && charges[ index ].price_list[ recordNO ].isEditing)) {
      this.handleOnItemsChange(recordNO, element, value, itemType, orderNo);
      }
    }

  };

  // handle no modify change for individual lines
  handleNoModifyChange = (record, hasModified, isSubItemList = false, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const index = _.findIndex(charges, { order_number: orderNo });
    const currentCharges = isSubItemList ? charges[ index ].individual_lines : charges[ index ].price_list;
    const elementIndex = _.findIndex(currentCharges, { id: record.id });
    if (elementIndex >= 0) {
      currentCharges[elementIndex]["is_modified"] = hasModified;
      this.handleOnChange(itemType, charges, () => {
        this.handleNoModifyCheckboxSave(record, hasModified);
      });
    }
    
  };

  handleNoModifyCheckboxSave = async(record, hasModified) => {
    const { invoice, selectedInfo } = this.state;
    const { currentOrg } = this.props.userContext;
    const payload = {
      organization_id: _.get(currentOrg, "id", ""),
      invoice_line_id: record.id,
      is_modified: hasModified,
      ...this.estimateApiParams(),
    };
    this.setState({ noModifyLoading: true});
    try {
      const response = await updateModifyStatus(payload);
      if (response.success) {
        const msg = response?.message ? response.message : "No auto calc status updated successfully.";
        alertMessage(msg, "success", 10);
        this.refreshDetails();
      } else {
        renderAlertMessage(response.errors, "error", 10);
      }
    } catch (error) {
      console.error("Error updating no auto calc checkbox:", error);
    }  finally {
      this.setState({ noModifyLoading: false });
    }
  }



    handleIndvItemsChange = (recordNO, element, value, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const index = _.findIndex(charges, { order_number: orderNo });
    if (element === "accessorial_code") {
      this.handleAccessorailChange(recordNO, element, value, itemType, orderNo);
    } else {
      if ((index >= 0 && charges[ index ].individual_lines[ recordNO ].isNew) || (index >= 0 && charges[ index ].individual_lines[ recordNO ].isEditing)) {
      this.handleIndvOnItemsChange(recordNO, element, value, itemType, orderNo);
      }
    }

  };

  handleUpdateRecords = (updatedRecords) => {
    this.setState({ ikeaChargesrecord: updatedRecords },()=>{
      this.findIkeaPriceTotal();
    });
  };

  findIkeaPriceTotal = () => {
    const { ikeaChargesrecord } = this.state;
    let totalAmount = 0;

    const amount = parseFloat(findTotal(ikeaChargesrecord, "invoice_value"));
    totalAmount += amount;

    this.handleOnChange("total_amount", totalAmount);
  };

  handleRecordUpdate = (recordNO, itemType, orderNo, data) => {
    const charges = [...this.state.invoice[itemType]];
    const index = _.findIndex(charges, { order_number: orderNo });
    if (index >= 0) {
      charges[index].price_list[recordNO] = data;
      this.handleOnChange(itemType, charges);
    }
  };

  handleOnItemsChange = (recordNO, element, value, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      charges[elementIndex].price_list[recordNO][element] = value;
      if (element === "location_id") {
        const pool = this.getLocationPoolForChargeItem(itemType, orderNo);
        charges[elementIndex].price_list[recordNO].location_type =
          this.resolveLocationTypeForLocationId(value, pool);
      }
      if (element === "accessorial_code" && !isEmpty(value)) {
        const accessorials = this.state.accessorials || [];
        const currentAccRecord = _.find(accessorials, {
          accessorial_code: value,
        });
        if (!isEmpty(currentAccRecord)) {
          charges[elementIndex].price_list[recordNO]["gl_code"] =
            currentAccRecord.gl_code;
        }
      }
      this.handleOnChange(itemType, charges, () => {
        this.findPriceTotal();
      });
    }
  };

    handleIndvOnItemsChange = (recordNO, element, value, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      charges[elementIndex].individual_lines[recordNO][element] = value;
      if (element === "location_id") {
        const pool = this.getLocationPoolForChargeItem(itemType, orderNo);
        charges[elementIndex].individual_lines[recordNO].location_type =
          this.resolveLocationTypeForLocationId(value, pool);
      }
      if (element === "accessorial_code" && !isEmpty(value)) {
        const accessorials = this.state.accessorials || [];
        const currentAccRecord = _.find(accessorials, {
          accessorial_code: value,
        });
        if (!isEmpty(currentAccRecord)) {
          charges[elementIndex].individual_lines[recordNO]["gl_code"] =
            currentAccRecord.gl_code;
        }
      }
      this.handleOnChange(itemType, charges, () => {
        this.findIndvPriceTotal();
      });
    }
  };

  handleAccessorailChange = (recordNO, element, value, itemType, orderNo) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const invoiceLines = charges[elementIndex].price_list || [];
      const accessorials = this.state.accessorials || [];
      const currentAccessorial = _.find(accessorials, {
        accessorial_code: value,
      });
      if (
        !isEmpty(currentAccessorial) &&
        !isEmpty(currentAccessorial.standard_code)
      ) {
        const accessorialCodes = accessorials
          .filter(
            (accessorial) =>
              accessorial.standard_code === currentAccessorial.standard_code
          )
          .map((accessorial) => accessorial.accessorial_code);
        const existanceRecords = invoiceLines
          .filter((line) => accessorialCodes.includes(line.accessorial_code))
          .map((line) => line.invoice_name);
        if (existanceRecords.length > 0) {
          confirm({
            title: I18n.t("messages.standard_change_confirm", {
              field: existanceRecords.join(", "),
            }),
            content: <span>{I18n.t("messages.proceed_confirm")}</span>,
            onOk: () => {
              this.handleOnItemsChange(
                recordNO,
                element,
                value,
                itemType,
                orderNo
              );
            },
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onCancel: () => {
              this.handleOnItemsChange(
                recordNO,
                element,
                "",
                itemType,
                orderNo
              );
            },
          });
        } else {
          this.handleOnItemsChange(recordNO, element, value, itemType, orderNo);
        }
      } else {
        this.handleOnItemsChange(recordNO, element, value, itemType, orderNo);
      }
    }
  };

  // addItem = (itemType, orderNo,locations) => {
  //   const { config } = this.state;
  //   const charges = [...this.state.invoice[itemType]];
  //   const index = _.findIndex(charges, { order_number: orderNo });
  //   if (index >= 0) {
  //     const data = {
  //       invoice_name: "",
  //       invoice_value: "",
  //       invoice_quantity: 1,
  //       // sign: 'CR',
  //       isNew: true,
  //       invoice_type: I18n.t(`invoices.invoice_types.${itemType}`),
  //       order_item_group_id: null,
  //       // location_id:locations?.length === 1 ? locations[0].location_id : ''
  //       location_id : locations.length ? locations[0].location_id : ''
  //     };

  //     if (itemType !== "adjustment_charges") {
  //       data.accessorial_code = "";
  //     }
      
  //     if (itemType === "adjustment_charges") {
  //       data.apply_driver_pay_for_adjustment = false;
  //     }

  //     data.order_id = charges[index].order_id;
  //     if (itemType === "fuel_surcharges") {
  //       data.gl_code = config["fuel_surcharge_gl_code"];
  //     }
  //     charges[index].price_list.push(data);
  //     charges[index].price_list = charges[index].price_list.map((item) => {
  //       item.isEditing = false;
  //       return item;
  //     });
  //     this.setState({
  //       editedFuelPercent: "",
  //       currentProcessedId: ""
  //     })
  //     this.handleOnChange(itemType, charges);
  //     if (this.state.currentOrderGroupType === "TEMPLATE") {
  //       const updatedIkeaChargesRecord = [
  //         ...this.state.ikeaChargesrecord,
  //         data,
  //       ];

  //       // Convert the array to a Set to remove duplicates, then back to an array
  //       const uniqueIkeaChargesRecord = Array.from(
  //         new Set(updatedIkeaChargesRecord.map((item) => JSON.stringify(item)))
  //       ).map((item) => JSON.parse(item));

  //       this.setState({
  //         ikeaChargesrecord: uniqueIkeaChargesRecord,
  //       });
  //     }
  //   }
  // };

  addItem = (itemType, orderNo,locations, currentSection) => {
    const { config } = this.state;
    
    // use cloneDeep to avoid mutating state directly
    const charges = _.cloneDeep(this.state.invoice[itemType]);
    const prevCharges = _.cloneDeep(this.state.rawInvoice[itemType]);
    
    const index = _.findIndex(charges, { order_number: orderNo });
    if (index >= 0) {
      const defaultLocId = locations.length
        ? (currentSection?.is_single_segment ? locations.at(-1).location_id : locations[0].location_id)
        : "";
      const data = {
        invoice_name: "",
        invoice_value: "",
        invoice_quantity: 1,
        // sign: 'CR',
        isNew: true,
        invoice_type: I18n.t(`invoices.invoice_types.${itemType}`),
        order_item_group_id: null,
        location_id: defaultLocId,
        location_type: this.resolveLocationTypeForLocationId(defaultLocId, locations),
        order_id: charges[index].order_id,
      };

      if (itemType !== "adjustment_charges") data.accessorial_code = "";
      if (itemType === "adjustment_charges") data.apply_driver_pay_for_adjustment = false;
      if (itemType === "fuel_surcharges") data.gl_code = config["fuel_surcharge_gl_code"];

      //get old saved price_list
      const oldPriceList = prevCharges[index]?.price_list || [];

      //reset isEditing for existing items
      const resetOldPriceList = oldPriceList.map((item) => ({ ...item, isEditing: false }));

      //merge old price_list with new item instead of overwriting
      charges[index].price_list = [...resetOldPriceList, data];

      this.setState({
        editedFuelPercent: "",
        currentProcessedId: ""
      })
      // update UI
      this.handleOnChange(itemType, charges);
      if (this.state.currentOrderGroupType === "TEMPLATE") {
        const updatedIkeaChargesRecord = [
          ...this.state.ikeaChargesrecord,
          data,
        ];

        // Convert the array to a Set to remove duplicates, then back to an array
        const uniqueIkeaChargesRecord = Array.from(
          new Set(updatedIkeaChargesRecord.map((item) => JSON.stringify(item)))
        ).map((item) => JSON.parse(item));

        this.setState({
          ikeaChargesrecord: uniqueIkeaChargesRecord,
        });
      }
    }
  };

   addIndvItem = (itemType, orderNo,locations, currentSection) => {
    const { config } = this.state;
    
    // use cloneDeep to avoid mutating state directly
    const charges = _.cloneDeep(this.state.invoice[itemType]);
    const prevCharges = _.cloneDeep(this.state.rawInvoice[itemType]);
    
    const index = _.findIndex(charges, { order_number: orderNo });
    if (index >= 0) {
      const defaultLocIdIndv = locations.length
        ? (currentSection?.is_single_segment ? locations.at(-1).location_id : locations[0].location_id)
        : "";
      const data = {
        invoice_name: "",
        invoice_value: "",
        invoice_quantity: 1,
        // sign: 'CR',
        isNew: true,
        invoice_type: I18n.t(`invoices.invoice_types.${itemType}`),
        order_item_group_id: null,
        location_id: defaultLocIdIndv,
        location_type: this.resolveLocationTypeForLocationId(defaultLocIdIndv, locations),
        order_id: charges[index].order_id,
      };

      if (itemType !== "adjustment_charges") data.accessorial_code = "";
      if (itemType === "adjustment_charges") data.apply_driver_pay_for_adjustment = false;
      if(["transportation_charges", "fuel_surcharges"].includes(this.props.invoice_type)){
        data.is_modified = false;
      }
      if (itemType === "fuel_surcharges") data.gl_code = config["fuel_surcharge_gl_code"];

      //get old saved price_list
      const oldIndvPriceList = prevCharges[index]?.individual_lines || [];

      //reset isEditing for existing items
      const resetOldPriceList = oldIndvPriceList.map((item) => ({ ...item, isEditing: false }));

      //merge old price_list with new item instead of overwriting
      charges[index].individual_lines = [...resetOldPriceList, data];

      this.setState({
        editedFuelPercent: "",
        currentProcessedId: ""
      })
      // update UI
      this.handleOnChange(itemType, charges);
      if (this.state.currentOrderGroupType === "TEMPLATE") {
        const updatedIkeaChargesRecord = [
          ...this.state.ikeaChargesrecord,
          data,
        ];

        // Convert the array to a Set to remove duplicates, then back to an array
        const uniqueIkeaChargesRecord = Array.from(
          new Set(updatedIkeaChargesRecord.map((item) => JSON.stringify(item)))
        ).map((item) => JSON.parse(item));

        this.setState({
          ikeaChargesrecord: uniqueIkeaChargesRecord,
        });
      }
    }
  };

  editItem = (index, itemType, itemId, record, locations) => {
    if (record && record.isEditing) {
      const { invoice, rawInvoice } = this.state;
      const updatedOrder = _.cloneDeep(invoice);
      const previousOrder = _.cloneDeep(rawInvoice);

      // find index 
      const priceListIndex = _.findIndex(previousOrder[itemType], (item) =>
        item.price_list.find((line) => line.id === itemId)
      );
      const priceListToEdit = previousOrder[itemType][priceListIndex];
      const priceList = priceListToEdit.price_list || [];
      let updatedPriceList = []
      updatedPriceList = priceList.filter((item) => !item.isNew);
      updatedPriceList = updatedPriceList.map((item, i) =>
        i === index ? { ...item, isEditing: true } : { ...item, isEditing: false }
      );

      updatedOrder[itemType][priceListIndex].price_list = updatedPriceList;
      // Step 3: replace the price_list entirely (no leftover references)
      _.set(updatedOrder, [itemType, priceListIndex, "price_list"], updatedPriceList);
      // _.set(updatedRawOrder, [itemType, priceListIndex, "price_list"], updatedPriceList);
      
      //reset editing of fuel percent
      this.setState({
        editedFuelPercent: "",
        currentProcessedId: "",
      })
      this.handleOnChange(itemType, updatedOrder[itemType]);
    }
  }

    editIndvItem = (index, itemType, itemId, record, locations) => {
    if (record && record.isEditing) {
      const { invoice, rawInvoice } = this.state;
      const updatedOrder = _.cloneDeep(invoice);
      const previousOrder = _.cloneDeep(rawInvoice);

      // find index 
      const indvListIndex = _.findIndex(previousOrder[itemType], (item) =>
        item.individual_lines.find((line) => line.id === itemId)
      );
      const indvListToEdit = previousOrder[itemType][indvListIndex];
      const indvList = indvListToEdit.individual_lines || [];
      let updatedIndvList = []
      updatedIndvList = indvList.filter((item) => !item.isNew);
      updatedIndvList = updatedIndvList.map((item, i) =>
        i === index ? { ...item, isEditing: true } : { ...item, isEditing: false }
      );

      updatedOrder[itemType][indvListIndex].individual_lines = updatedIndvList;
      // Step 3: replace the individual_lines entirely (no leftover references)
      _.set(updatedOrder, [itemType, indvListIndex, "individual_lines"], updatedIndvList);
      // _.set(updatedRawOrder, [itemType, priceListIndex, "price_list"], updatedPriceList);
      
      //reset editing of fuel percent
      this.setState({
        editedFuelPercent: "",
        currentProcessedId: "",
      })
      this.handleOnChange(itemType, updatedOrder[itemType]);
    }
  }

  // editItem = (index, itemType, itemId, record, locations) => {
  //   if (record && record.isEditing) {
  //     const { invoice, rawInvoice } = this.state;

  //     // Deep clone both
  //     const updatedOrder = _.cloneDeep(invoice);
  //     const updatedRawOrder = _.cloneDeep(rawInvoice);

  //     // find correct index based on saved invoice (rawInvoice)
  //     const priceListIndex = _.findIndex(updatedRawOrder[itemType], (item) =>
  //       item.price_list.some((line) => line.id === itemId)
  //     );

  //     if (priceListIndex === -1) return; // no match found

  //     // get the corresponding price_list from updatedOrder
  //     const priceList = _.get(updatedOrder, [itemType, priceListIndex, "price_list"], []);

  //     // Step 1: remove all isNew items
  //     let updatedPriceList = priceList.filter((item) => !item.isNew);

  //     // Step 2: mark only the clicked index as editing
  //     updatedPriceList = updatedPriceList.map((item, i) =>
  //       i === index ? { ...item, isEditing: true } : { ...item, isEditing: false }
  //     );

  //     // Step 3: replace the price_list entirely (no leftover references)
  //     _.set(updatedOrder, [itemType, priceListIndex, "price_list"], updatedPriceList);
  //     _.set(updatedRawOrder, [itemType, priceListIndex, "price_list"], updatedPriceList);
  //     // Step 4: reset related state
  //     this.setState({
  //       editedFuelPercent: "",
  //       currentProcessedId: "",
  //       // rawInvoice: updatedRawOrder,
  //     })
  //     // Step 5: update invoice via handleOnChange
  //     this.handleOnChange(itemType, updatedOrder[itemType]);
  //   }
  // }

  // cancelEditItem = (index, itemType, itemId) => {
  //   const { invoice, rawInvoice } = this.state;
  //   // Clone the invoices to avoid mutating the state directly
  //   const updatedOrder = _.cloneDeep(invoice);
  //   const previousOrder = _.cloneDeep(rawInvoice);
  //   // Retrieve the price lists from both the updated and previous invoices
  //   const priceList = updatedOrder[itemType][0].price_list || [];
  //   const previousPriceList = previousOrder[itemType][0].price_list || [];
  //   // Map through the price list to update isEditing and restore original data
  //   const updatedPriceList = priceList.map((item) => {
  //     if (item.id === itemId) {
  //       // Set isEditing to false for the item being canceled
  //       item.isEditing = false;
  //       // Retrieve the original data from the previous order
  //       const originalItem = previousPriceList.find(
  //         (prevItem) => prevItem.id === itemId
  //       );
  //       // Return the original data if found, otherwise keep the current data
  //       return originalItem ? originalItem : item;
  //     } else {
  //       // Keep other items unchanged
  //       return item;
  //     }
  //   });
  //   // Update the price list in the updated order
  //   updatedOrder[itemType][0].price_list = updatedPriceList;
  //   this.setState({removeEditingVals: true})
  //   // Call handleOnChange to update the state with the modified order
  //   this.handleOnChange(itemType, updatedOrder[itemType], () => {
  //     this.findPriceTotal();
  //     this.setState({removeEditingVals: false})
  //   });
  // };

  cancelEditItem = (index, itemType, itemId, orderId) => {
    const { invoice, rawInvoice } = this.state;
    // Clone the invoices to avoid mutating the state directly
    const updatedOrder = _.cloneDeep(invoice);
    const previousOrder = _.cloneDeep(rawInvoice);

    // Find the current and previous matching records based on orderId
    const matchedCurrent = updatedOrder[itemType]?.find((rec) => rec.order_id === orderId);
    const matchedPrevious = previousOrder[itemType]?.find((rec) => rec.order_id === orderId);

    const priceList = matchedCurrent.price_list || [];
    const previousPriceList = matchedPrevious?.price_list || [];

    // Update the price list by restoring data from previous order and disabling isEditing
    const updatedPriceList = priceList.map((item) => {
      if (item.id === itemId) {
        const originalItem = previousPriceList.find((prevItem) => prevItem.id === itemId);

        return {
          ...(originalItem || item), // fallback to current if not found
          isEditing: false,
        };
      }

      // Preserve other items
      return { ...item };
    });

    // Replace the price_list in the updated order
    matchedCurrent.price_list = updatedPriceList;

    // Temporarily flag that editing values are being removed
    this.setState({removeEditingVals: itemId})
    // Use handleOnChange to update state and recalculate total
    this.handleOnChange(itemType, updatedOrder[itemType], () => {
      this.findPriceTotal();
      this.setState({removeEditingVals: null})
    });
  };

    indvCancelEditItem = (index, itemType, itemId, orderId) => {
    const { invoice, rawInvoice } = this.state;
    // Clone the invoices to avoid mutating the state directly
    const updatedOrder = _.cloneDeep(invoice);
    const previousOrder = _.cloneDeep(rawInvoice);

    // Find the current and previous matching records based on orderId
    const matchedCurrent = updatedOrder[itemType]?.find((rec) => rec.order_id === orderId);
    const matchedPrevious = previousOrder[itemType]?.find((rec) => rec.order_id === orderId);

    const indvPriceList = matchedCurrent.individual_lines || [];
    const indvPreviousPriceList = matchedPrevious?.individual_lines || [];

    // Update the price list by restoring data from previous order and disabling isEditing
    const indvUpdatedPriceList = indvPriceList.map((item) => {
      if (item.id === itemId) {
        const originalItem = indvPreviousPriceList.find((prevItem) => prevItem.id === itemId);

        return {
          ...(originalItem || item), // fallback to current if not found
          isEditing: false,
        };
      }

      // Preserve other items
      return { ...item };
    });

    // Replace the individual_lines in the updated order
    matchedCurrent.individual_lines = indvUpdatedPriceList;

    // Temporarily flag that editing values are being removed
    this.setState({removeIndvEditingVals: itemId})
    // Use handleOnChange to update state and recalculate total
    this.handleOnChange(itemType, updatedOrder[itemType], () => {
      this.findIndvPriceTotal();
      this.setState({removeIndvEditingVals: null})
    });
  };



  handleDeleteclick = (recordNO, itemType, orderNo, isSubItemList = false) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      // const cuttentInvoiceItem = charges[elementIndex].price_list
      //   ? (
      //     itemType !== 'transportation_charges' ?
      //     charges[elementIndex].price_list.sort((a, b) => a.invoice_name ? (a.invoice_name.localeCompare(b.invoice_name)) : 1)[recordNO] :
      //     charges[elementIndex].price_list[recordNO]
      //     )
      //   : {};
      const cuttentInvoiceItem = charges[elementIndex].price_list
      ? 
        charges[elementIndex].price_list[recordNO]
      : {};
      if (cuttentInvoiceItem?.id) {
        if(this.state.currentOrderGroupType === "TEMPLATE"){
          const newIkeaChargesRecord = this.state.ikeaChargesrecord.filter(
            (rec) => rec?.isNew
          );
          this.setState({newIkeaChargesRecord})
        }
        this.handleDeleteInvoiceItem(cuttentInvoiceItem.id, itemType, isSubItemList);
      } else {
        charges[elementIndex].price_list.splice(recordNO, 1);
          if(this.state.currentOrderGroupType === "TEMPLATE"){
            const updatedIkeaChargesRecord = [...this.state.ikeaChargesrecord];
            updatedIkeaChargesRecord.splice(recordNO, 1);
            this.setState({
              ikeaChargesrecord: updatedIkeaChargesRecord,
            });
          }
        this.setState({
          errors: [],
        });
        this.handleOnChange(itemType, charges, () => {
          this.findPriceTotal();
        });
      }
    }
  };

    handleIndvDeleteclick = (recordNO, itemType, orderNo, isSubItemList = false) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const cuttentInvoiceItem = charges[elementIndex].individual_lines
      ? 
        charges[elementIndex].individual_lines[recordNO]
      : {};
      if (cuttentInvoiceItem?.id) {
        if(this.state.currentOrderGroupType === "TEMPLATE"){
          const newIkeaChargesRecord = this.state.ikeaChargesrecord.filter(
            (rec) => rec?.isNew
          );
          this.setState({newIkeaChargesRecord})
        }
        this.handleDeleteInvoiceItem(cuttentInvoiceItem.id, itemType, isSubItemList);
      } else {
        charges[elementIndex].individual_lines.splice(recordNO, 1);
          if(this.state.currentOrderGroupType === "TEMPLATE"){
            const updatedIkeaChargesRecord = [...this.state.ikeaChargesrecord];
            updatedIkeaChargesRecord.splice(recordNO, 1);
            this.setState({
              ikeaChargesrecord: updatedIkeaChargesRecord,
            });
          }
        this.setState({
          errors: [],
        });
        this.handleOnChange(itemType, charges, () => {
          this.findIndvPriceTotal();
        });
      }
    }
  };


  getManualBillingDetails = (id, modalElemet) => {
    this.setState({ isLoading: true });
    fetchManualBillingDetails(id).then((result) => {
      if (result.success) {
        const defaultInvoice = {
          description: {},
          account_details: {},
          customer_details: {},
          accessorial_charges: [],
          adjustment_charges: [],
          transportation_charges: [],
          order_info: {},
        };

        let currentInvoice = _.merge(defaultInvoice, result.invoice);
        currentInvoice.customer_order_id = id;
        currentInvoice.remarks = result.remarks || [];
        // Group orders + their machine pricing (FMP/SMP) for the estimate popover.
        currentInvoice.group_orders = result.group_orders || [];
        currentInvoice.status = result.billing_status;

        const error_logs = result.error_logs || [];
        currentInvoice.error_log = error_logs.filter(
          (err_log) => !_.isEmpty(err_log.error_log)
        );
        currentInvoice.error_messages = error_logs.filter(
          (err_log) => !_.isEmpty(err_log.error_message)
        );

        this.setState(
          {
            invoice: currentInvoice,
            isLoading: false,
          },
          () => {
            // if (modalElemet) {
            //   this.handleOnChange(modalElemet, true);
            // }
          }
        );
      } else {
        renderAlertMessage(result.errors);
        this.setState({
          invoice: {},
          isLoading: false,
        });
      }
    });
  };


  // getBillingDetails = (id, modalElemet) => {
  //   this.setState({ inProgress: true });
  //   fetchBillingDetails(id).then((result) => {
  //     if (result.success) {
  //       const currentInvoice = this.handleInvoiceResponse(result, id);
  //       this.setState(
  //         {
  //           // result.orders.customer_order
  //           invoice: currentInvoice,
  //           inProgress: false,
  //         },
  //         () => {
  //           // if (modalElemet) {
  //           //   this.handleOnChange(modalElemet, true);
  //           // }
  //         }
  //       );
  //     } else {
  //       renderAlertMessage(result.errors);
  //       this.setState({
  //         invoice: {},
  //         inProgress: false,
  //       });
  //     }
  //   });
  // };


  refreshDetails = () => {
    // Any charge change in the estimate (add/edit/delete/accessorial) affects the
    // order's billing, so mark the estimate dirty — the order-screen Details tab
    // then refreshes once on leaving the tab, same as a LoS change. No-op on the
    // Billing screen (handleIsLosChanged defaults to a no-op there). refreshDetails
    // is only called after user changes, never on initial load, so this is safe.
    this.props.handleIsLosChanged(true);
    if (this.state.invoice.order_group_type === "MANUAL") {
      this.getManualBillingDetails(this.state.invoice.order_number);
    } else {
      this.getBillingDetails(this.state.invoice.customer_order_id);
    }
  };

  handleDeleteInvoiceItem = (id, itemType = "", isSubItemList = false) => {
    this.setState({ inProgress: true });
    deleteInvoiceLine(id, this.estimateApiParams()).then((result) => {
      if (result.success) {
        if(isSubItemList){
          this.clearExpandedRowsByType(itemType);      
        }
        this.setState({ inProgress: false});
        alertMessage(I18n.t("messages.deleted"));
        if(this.state.invoice.status === "APPROVED"){
          this.handleSaveAndReapprove();
        }
        this.refreshDetails();
        // this.props.getInvoices();
      } else {
        renderAlertMessage(result.errors)
        this.setState({ inProgress: false });
      }
    });
  };

  imageAction = (id) => {
    const currentOrderPics = _.find(this.state.invoice.pod_pictures, {
      location_id: id,
    });
    this.setState({
      currentGalleryLocId : id,
      currentOrderPics: !isEmpty(currentOrderPics)
        ? _.cloneDeep(currentOrderPics)
        : {},
    });
  };

  getAccountConfigs = () => {
    this.setState({
      configLoading: true
    })
    const { config, invoice } = this.state;
    fetchAccountConfigs(
      invoice.account_details.id,
      userStore.getStateValue("selectedOrg"),
      "ALL"
    ).then((result) => {
      if (result.success) {
        const accountConfigurations = result.account_configurations || [];
        accountConfigurations.forEach((setting) => {
          config[setting.setting_name] = setting.setting_value;
        });
        if (
          !isEmpty(config.pod_pic_settings) &&
          _.isString(config.pod_pic_settings) &&
          config.pod_pic_settings === "[]"
        ) {
          config.pod_pic_settings = [];
        }
        config.pod_pic_settings = updatePicSettingsWithBol(
          config.pod_pic_settings
        );
        if (isEmpty(config.communication_preference)) {
          config.communication_preference = "SMSES";
        }
        this.setState({
          config,
          configLoading: false,
        });
      } else {
        renderAlertMessage(result.errors)
        this.setState({
          configLoading: false,
        });
      }
    });
  };

  onCloseUploadGallery = () => {
    this.setState(
      {
        imagesVisible: false,
        currentOrderPics: {},
        currentGalleryLocId: ""
      },
      () => {
        this.refreshDetails();
      }
    );
  };
  addOrdersToInvoice = () => {
    const payload = {
      organization_id: userStore.getStateValue("selectedOrg"),
      customer_order_id: this.state.invoice.customer_order_id,
      new_customer_order_numbers: this.state.additionalOrders,
    };
    this.setState({
      ordersAddingProgress: true,
    });
    addOrdersForBillingGroup(payload).then((result) => {
      if (result.success) {
        this.setState({
          ordersAddingProgress: false,
          showAddOrders: false,
          additionalOrders: "",
        });
        alertMessage(I18n.t("messages.orders_added"));
        this.refreshDetails();
        // this.props.getBillingDetails(
        //   this.props.currentInvoice.customer_order_id
        // );
      } else {
        renderAlertMessage(result.errors)
        this.setState({
          ordersAddingProgress: false,
        });
      }
    });
  };

  handleSaveReadyForBilling = async (from = "ON_HOLD") => {
    try {
      this.setState({ confirmModalLoading: true });
      const payload = {
        customer_order_ids: [this.props.activeRecordId],
        organization_id: userStore.getStateValue("selectedOrg"),
        ...(from === "ON_HOLD" || from === "PAPER_WORK_PENDING" || from === "PENDING" ? { description: this.state.description } : {})
      };
      let response = {};
      payload.status = (from === "PAPER_WORK_PENDING" || from === "PENDING") ? "PENDING" : (this.state.isOnHold == true ? "READY_FOR_BILLING" : "HOLD");
      response = await changeStatusOfInvoicesToHold(payload);
      if (response.success) {
        const result = response?.invoices ? response.invoices : {};
        const successMessage = result?.message
          ? result.message
          : I18n.t("messages.saved");
        //  typeof onSave === 'function' && onSave(I18n.t('messages.saved'))
        alertMessage(successMessage);
        this.setState({ openConfirmModal: false, description: "", confirmModalType: "", confirmModalLoading: false });
        this.props.closeModal();
        this.props.handleSuccess();
      } else {
        throw new Error(response.errors[0]);
      }
    } catch (error) {
      alertMessage(error.message, "error", 10);
      this.setState({ confirmModalLoading: false });
    }
  };

  renderAddOrders = () => {
    const additionalOrders = !isEmpty(this.state.additionalOrders)
      ? this.state.additionalOrders
      : "";
    return (
      <BaseModal
        title={I18n.t("general.customer_orders")}
        className="customer-orders-modal"
        onCancel={() => {
          this.setState({ showAddOrders: false, additionalOrders: "" });
        }}
        width="65%"
        maskClosable={false}
      >
        <Spin spinning={this.state.ordersAddingProgress} delay={1000}>
          <div className="tagsInput" data-testid="add-orders-modal">
            <Row type="flex" gutter={4}>
              <Col span={22}>
                {/* <Input
              autoFocus
              onChange={(e) => {
                this.setState({ additionalOrders: e.target.value });
              }}
            ></Input> */}
                <TagsInput
                  value={
                    additionalOrders.length ? additionalOrders.split(",") : []
                  }
                  onChange={(orderNums) =>
                    this.setState({ additionalOrders: orderNums.join(",") })
                  }
                  validationRegex={/^[a-zA-Z0-9_-]+$/}
                  onlyUnique
                  addOnPaste
                  pasteSplit={customPasteSplit}
                  inputProps={{
                    placeholder: "Add Orders",
                    "data-testid": "add-orders-input"
                  }}
                  addOnBlur={true}
                  autoFocus
                />
              </Col>
              <Col span={2}>
                <Button data-testid="add-order-button" type="primary" onClick={this.addOrdersToInvoice} icon="plus">
                  Add
                </Button>
              </Col>
            </Row>
          </div>
        </Spin>
      </BaseModal>
    );
  };

  handleSendingMails = () =>{
    if (!this.state.billingEmails.length) return alertMessage('Please enter atleast one email address', 'error');

    const account = this.state.invoice.account_details
    ? this.state.invoice.account_details
    : {};    
    
    let totalOrders = this.getInvoiceOrders();
    const selectedInfo = {
      selectedKeys: totalOrders.map((order) => order.order_id),
      selectedRows: [...totalOrders],
    };

    const payload = {
      account_id: account.id,
      customer_order_ids: [...selectedInfo.selectedKeys],
      organization_id: userStore.getStateValue('selectedOrg'),
      email_ids: this.state.billingEmails,
      subject: this.state.subject,
      description: this.state.description,
      ...this.estimateApiParams(),
    };
    this.setState({ isSendingMail: true });
    SendInvoiceEmail(payload).then((result) => {
      if (result.success) {
        alertMessage(result.message, 'success', 5);
        this.setState({ 
        // billingEmails: [],
        //   subject: "",
        //   description: "",
        });
      } else {
        alertMessage(result.message, 'error', 5);
      }
    }
    ).finally(() => { this.setState({ isSendingMail: false }); }
    );
  }

  renderEmailModal = () => {
    const description =  "Description" // I18n.t("general.body")
    const subject = "Subject" // I18n.t("general.subject")
    return (
      <BaseModal
        title={ I18n.t("general.send_to", { from: I18n.t("invoices.billing"), to: "Emails" }) }
        onCancel={ () => this.setState({
          showEmailModal: false,
          billingEmails:[]
        }) }
        width="50%"
        style={ { top: 40 } }
        maskClosable={ false }
      >
        <Spin spinning={this.state.isEmailLoading}>
        <Row className="tagsInput emailForm" type='flex' align='middle' gutter={8}>
          <Col span={ 21 }>
            {/* <FormItem label= {I18n.t('general.email')} require>
              <EmailsInput emails={ this.state.billingEmails } onChange={ this.addBilligEmail } />
            </FormItem> */}
            <FormItem label={I18n.t('general.email')}>
            <Select
                  data-testid="invoice-email-input"
                  value = {this.state.billingEmails}
                  onChange={this.addBilligEmail}
                  mode="tags"
                  validationRegex = {this.addBilligEmail}
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Enter or select Emails"
                  tokenSeparators={[","]}
                >
                 {
                  this.state.contacts.map(opt => <Option key={opt}>{opt}</Option>)
                 }
                </Select>
                </FormItem>
          </Col>
          <Col span={ 3 } className="alignRight">
              <Button data-testid="invoice-send-email-button" type="primary" loading={ this.state.isSendingMail } icon='mail' onClick={this.handleSendingMails}>
                Send
              </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormItem label={subject}>
              <Input
                data-testid="invoice-email-subject"
                rows={4}
                placeholder={subject}
                className="sop-form-textArea"
                value={this.state.subject}
                onChange={(e) => this.setState({subject: e.target.value})}
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormItem label={description}>
              <TextArea
                data-testid="invoice-email-description"
                rows={4}
                placeholder={description}
                className="sop-form-textArea"
                value={this.state.description}
                onChange={(e) => this.setState({description: e.target.value})}
              />
            </FormItem>
          </Col>
        </Row>
        </Spin>

      </BaseModal>
    );
  }

  closeDriverPayWindow = () => {
    this.setState(
      {
        currentInvoice:
          this.state.showGroupOrder === true ? this.state.currentInvoice : {},
        showDriverPayForm: false,
      },
      () => {
        this.refreshDetails();
      }
    );
  };


  renderDriverPayModal = () => {
    const currentInvoice = { ...this.state.invoice };
    return (
      <BaseModal
        title={ `${I18n.t("invoices.billing")} #${this.state.invoice.order_number
          }` }
        onCancel={ () => this.closeDriverPayWindow() }
        width="70%"
        style={ { top: 50 } }
        bodyStyle={ { padding: 20 } }
      >
        <DriverPayDetails
          currentInvoice={ currentInvoice }
          isNew={ false }
          onCancel={ () => this.closeDriverPayWindow() }
          onChange={ (element, value) => this.handleOnChange(element, value) }
          getInvoiceDetails={ (orderId) => this.getBillingDetails(orderId) }
          showHeaders={ this.state.showGroupOrder !== true }
          handleOrderDetailsViewClick={ (order_id) => { }
          }
          showRemarks={ false }
          driversList = {this.state.driversList}
        />
      </BaseModal>
    );
  };

  renderUploadGallery = () => {
    return (
      <BaseModal
        title={I18n.t("order.upload_images")}
        onCancel={this.onCloseUploadGallery}
        visible={this.state.imagesVisible}
        width="70%"
        style={{ top: 30 }}
        maskClosable={false}
      >
        <UploadGallery
          config={this.state.config}
          refreshOrder={this.refreshDetails}
          key={this.state.uploadKey}
          closeGallery={this.onCloseUploadGallery}
          uploadApi={uploadPod}
          deleteAttachments={deleteOrderPic}
          currentOrderPics={this.state.currentOrderPics}
          refer={"invoice"}
          invoice={this.state.invoice}
        />
      </BaseModal>
    );
  };

  renderOrderPics = () => {
    const { pod_pictures: podPics } = this.state.invoice;
    // The billing POD leg (get_order_pictures_with_location) carries no lock
    // flag, so derive per-order lock from the invoice's transportation_charges
    // (order_id -> is_locked). Without this, Documents.jsx leaves every POD
    // section unlocked and shows upload/delete controls on a locked invoice.
    const orderLockMap = {};
    (_.get(this.state.invoice, "transportation_charges", []) || []).forEach(
      (charge) => {
        if (charge && charge.order_id != null) {
          orderLockMap[String(charge.order_id)] =
            String(charge.is_locked) === "true";
        }
      }
    );
    if (
      this.state.invoice.order_group_type !== "MANUAL" &&
      podPics &&
      podPics.length > 0
    ) {
      return (
        <Fragment>
          <Spin spinning={this.state.configLoading} tip="Fetching POD's Details...">
          <Row gutter={[16, 4]} type="flex">
            {podPics.map((leg, index) => {
              // Adapter: map a billing POD leg -> the shape Documents.jsx expects
              // (the new order-screen documents component, rendered per leg).
              const locObj = {
                id: leg.location_id,
                type_of_loc: leg.type_of_loc,
                // label_code drives the "Pickup/Delivery Documents" heading.
                label_code:
                  leg.type_of_loc === "DELIVERY" ||
                  ["D", "TD"].includes(leg.type_of_order)
                    ? "D"
                    : "R",
              };
              const documents = (leg.pictures || [])
                .map((p) => ({
                  ...p,
                  // Documents.jsx reads a flat picture_url + id.
                  picture_url: p.picture ? p.picture.url : null,
                  id: p._id,
                }))
                .filter((d) => d.picture_url != null);
              // The reused Documents component never renders sign_by /
              // title_by_relation, so surface the delivery-signature metadata
              // here from the signature picture on this leg (as the old POD
              // card did).
              const signatureObject =
                (leg.pictures || []).find(
                  (p) => p.image_type === "signature" && p.sign_by
                ) || {};
              const currentOrder = {
                id: leg.customer_order_id,
                type_of_order: leg.type_of_order,
                customer_order_number: leg.customer_order_number,
                status: leg.status,
                customer_order_details: {
                  // Documents gates upload/delete on is_locked (string
                  // "true"/"false"). Lock when this leg's order is locked or the
                  // invoice is on hold.
                  is_locked:
                    this.state.isOnHold ||
                    orderLockMap[String(leg.customer_order_id)]
                      ? "true"
                      : "false",
                  has_tender: leg.has_tender,
                },
              };
              // Billing-specific section heading: "<orderNo>(P)" / "<orderNo>(D)".
              // Use the leg's pickup/delivery type for every order (T/LH legs set
              // type_of_loc; normal orders fall back to type_of_order mapping).
              const locSuffix =
                leg.type_of_loc === "PICKUP" ||
                ["R", "TR"].includes(leg.type_of_order)
                  ? "(P)"
                  : leg.type_of_loc === "DELIVERY" ||
                    ["D", "TD"].includes(leg.type_of_order)
                  ? "(D)"
                  : "";
              const headingOverride = `${leg.customer_order_number}${locSuffix}`;
              return (
                // Two orders picked up at the same CS location share a
                // location_id, so key on customer_order_id too to avoid
                // duplicate React keys across POD cards.
                <Col
                  md={12}
                  key={`${leg.customer_order_id}_${leg.location_id || index}`}
                >
                  <Documents
                    config={this.state.config}
                    actionType="view"
                    locObj={locObj}
                    currentOrder={currentOrder}
                    typeOfOrder={leg.type_of_order}
                    documents={documents}
                    accountId={_.get(
                      this.state.invoice,
                      "account_details.id",
                      ""
                    )}
                    refreshDetails={this.refreshDetails}
                    showActions={
                      this.state.showActions || this.isFromPendingBucket()
                    }
                    isShipper={false}
                    orderTypeConfig={{}}
                    headingOverride={headingOverride}
                  />
                  {!_.isEmpty(signatureObject) && signatureObject.sign_by && (
                    <Row>
                      <Col xs={24}>
                        <h4 className="alignLeft">
                          {I18n.t("order.sign_by")}{" "}
                          <span className="textCaptilize">
                            {signatureObject.sign_by}
                          </span>{" "}
                          {!_.isEmpty(signatureObject.title_by_relation) && (
                            <span className="textCaptilize">
                              ( {signatureObject.title_by_relation} )
                            </span>
                          )}
                          {signatureObject.captured_at
                            ? ` at ${formatByTimeConfig(
                                moment.utc(signatureObject.captured_at),
                                this.state.organizationSettings[
                                  "is_military_time"
                                ],
                                "Do MMM YYYY, HH:mm",
                                "Do MMM YYYY, hh:mm A"
                              )} ${leg.order_tz_short_name || ""}`
                            : ""}
                        </h4>
                      </Col>
                    </Row>
                  )}
                </Col>
              );
            })}
          </Row>
          </Spin>
        </Fragment>
      );
    }
    return <Fragment />;
  };

  handleInputSaveItem = (recordNO, itemType, orderNo, data) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      this.setState({ isSaving: true }) 
      let priceList = charges[elementIndex].price_list[recordNO]
      priceList.invoice_name = data.invoice_name;
      priceList.gl_code = data.gl_code;
      priceList.invoice_quantity = data.invoice_quantity;
      priceList.invoice_value = data.invoice_value;
      this.handleOnChange(itemType, charges, () => {
        this.findPriceTotal();
      });
      this.handleSaveItem(recordNO, itemType, orderNo)
    }
  }

    handleIndvInputSaveItem = (recordNO, itemType, orderNo, data) => {
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      this.setState({ isSaving: true }) 
      let priceList = charges[elementIndex].individual_lines[recordNO]
      priceList.invoice_name = data.invoice_name;
      priceList.gl_code = data.gl_code;
      priceList.invoice_quantity = data.invoice_quantity;
      priceList.invoice_value = data.invoice_value;
      this.handleOnChange(itemType, charges, () => {
        this.findIndvPriceTotal();
      });
      this.handleIndvSaveItem(recordNO, itemType, orderNo)
    }
  }

  handleSaveItem = (index, itemType, orderNo) => {
    const { invoice } = this.state;
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const typeObject = invoice[itemType][elementIndex] || {};
      const priceList = typeObject.price_list || [];
      const item = priceList[index];
      const errors = doValidate(requiredFields, item, `Item  ${index + 1}`);
      // if (itemType === "accessorial_charges" && isEmpty(item.accessorial_key)) {
      //   errors.push(
      //     `Item  ${index + 1} ${I18n.t("errors.field_required", {
      //       field: I18n.t("order.accessorial"),
      //     })}`
      //   );
      // }
      if (errors.length > 0) {
        this.setState({ errors, inProgress: false, isSaving: false });
      } else {
        let newInvoiceLines = [];
        const invoiceLines = priceList.filter((line) => line.isNew === true || line.isEditing === true );

        // Get raw price list for original location lookup
        const rawCharges = [...this.state.rawInvoice[itemType]];
        const rawElementIndex = _.findIndex(rawCharges, { order_number: orderNo });
        const rawPriceList = rawElementIndex >= 0
          ? (rawCharges[rawElementIndex].price_list || [])
          : [];

        if (itemType === "accessorial_charges") {
          invoiceLines.forEach((line) => {
            const newLine = Object.assign({}, line);
            const accessorialIndex = _.findIndex(this.state.accessorials, [
              "accessorial_code",
              line.accessorial_code,
            ]);
            if (accessorialIndex >= 0) {
              newLine.invoice_name =
                this.state.accessorials[accessorialIndex].accessorial_name;
              newLine.account_accessorial_id =
                this.state.accessorials[accessorialIndex].id;
            }
            newLine.invoice_type =
              itemType === "accessorial_charges" ? "Accessorial" : itemType;

            newInvoiceLines.push(
              this.enrichInvoiceLineForSave(newLine, itemType, orderNo, rawPriceList)
            );
          });
        } else {
          newInvoiceLines = invoiceLines.map((line) =>
            this.enrichInvoiceLineForSave(line, itemType, orderNo, rawPriceList)
          );
        }
        if (invoice.order_group_type === "MANUAL") {
          const data = {
            new_invoice_lines: newInvoiceLines,
            remark: "",
            order_group_type: invoice.order_group_type,
            invoice_number:
              invoice.order_group_type === "ORDER"
                ? invoice.customer_order_id
                : invoice.order_number,
            status: invoice.status,
            account_id: invoice.account_details.id,
            driver_id: invoice.driver_id,
            warehouse_id: invoice.warehouse_id,
          };
          saveNewInvoice(data).then((result) => {
            if (result.success) {
              alertMessage(I18n.t("messages.saved"));
              this.setState(
                {
                  inProgress: false,
                  errors,
                  isSaving: false
                },
                () => {
                  // this.props.getInvoices();
                }
              );
              this.getManualBillingDetails(
                this.state.invoice.order_number
              );
            } else {
              alertMessage(result.errors, "error", 10);
              this.setState({ inProgress: false, isSaving: false }, () => {
                if (!item.id) {
                  this.handleDeleteclick(index, itemType, orderNo, false);
                }
              });
            }
          }).then(() => {
            // call save and reapprove if in approval status
            if (invoice.status === "APPROVED") {
              this.handleSaveAndReapprove();
            }
          });

        } else {
          const orderInfo = invoice.order_info || {};
          const data = {
            new_invoice_lines: newInvoiceLines,
            remark: "",
            order_group_type: invoice.order_group_type,
            customer_order_id: typeObject.order_id || orderInfo.order_id || "",
            reference_id:
              invoice.order_group_type === "ORDER"
                ? invoice.customer_order_id
                : invoice.order_number,
            status: invoice.status,
            ...this.estimateApiParams(),
          };
          updateInvoiceLines(data).then((result) => {
            if (result.success) {
              alertMessage(I18n.t("messages.saved"));
              this.setState(
                {
                  inProgress: false,
                  errors,
                  isSaving: false
                },
                () => {
                  // this.props.getInvoices();
                }
              );
              this.getBillingDetails(
                this.state.invoice.customer_order_id
              );
            } else {
              alertMessage(result.errors, "error", 10);
              this.setState({ inProgress: false, isSaving: false }, () => {
                if (!item.id) {
                  this.handleDeleteclick(index, itemType, orderNo, false);
                }
              });
            }
          }).then(() => {
            // call save and reapprove if in approval status
            if (invoice.status === "APPROVED") {
              this.handleSaveAndReapprove();
            }
          });
        }
      }
    } else {
      this.setState({ isSaving: false }) 
    }
  };

    handleIndvSaveItem = (index, itemType, orderNo) => {
    const { invoice } = this.state;
    const charges = [...this.state.invoice[itemType]];
    const elementIndex = _.findIndex(charges, { order_number: orderNo });
    if (elementIndex >= 0) {
      const typeObject = invoice[itemType][elementIndex] || {};
      const indvPriceList = typeObject.individual_lines || [];
      const item = indvPriceList[index];
      const errors = doValidate(requiredFields, item, `Item  ${index + 1}`);
      // if (itemType === "accessorial_charges" && isEmpty(item.accessorial_key)) {
      //   errors.push(
      //     `Item  ${index + 1} ${I18n.t("errors.field_required", {
      //       field: I18n.t("order.accessorial"),
      //     })}`
      //   );
      // }
      if (errors.length > 0) {
        this.setState({ errors, inProgress: false, isSaving: false });
      } else {
        let newInvoiceLines = [];
        const invoiceLines = indvPriceList.filter((line) => line.isNew === true || line.isEditing === true );

        const rawChargesIndv = [...this.state.rawInvoice[itemType]];
        const rawElementIndexIndv = _.findIndex(rawChargesIndv, { order_number: orderNo });
        const rawIndvListForSave = rawElementIndexIndv >= 0
          ? (rawChargesIndv[rawElementIndexIndv].individual_lines || [])
          : [];

        if (itemType === "accessorial_charges") {
          invoiceLines.forEach((line) => {
            const newLine = Object.assign({}, line);
            const accessorialIndex = _.findIndex(this.state.accessorials, [
              "accessorial_code",
              line.accessorial_code,
            ]);
            if (accessorialIndex >= 0) {
              newLine.invoice_name =
                this.state.accessorials[accessorialIndex].accessorial_name;
              newLine.account_accessorial_id =
                this.state.accessorials[accessorialIndex].id;
            }
            newLine.invoice_type =
              itemType === "accessorial_charges" ? "Accessorial" : itemType;
            newInvoiceLines.push(
              this.enrichInvoiceLineForSave(newLine, itemType, orderNo, rawIndvListForSave)
            );
          });
        } else {
          newInvoiceLines = invoiceLines.map((line) =>
            this.enrichInvoiceLineForSave(line, itemType, orderNo, rawIndvListForSave)
          );
        }
        if (invoice.order_group_type === "MANUAL") {
          const data = {
            new_invoice_lines: newInvoiceLines,
            remark: "",
            order_group_type: invoice.order_group_type,
            invoice_number:
              invoice.order_group_type === "ORDER"
                ? invoice.customer_order_id
                : invoice.order_number,
            status: invoice.status,
            account_id: invoice.account_details.id,
            driver_id: invoice.driver_id,
            warehouse_id: invoice.warehouse_id,
          };
          saveNewInvoice(data).then((result) => {
            if (result.success) {
              alertMessage(I18n.t("messages.saved"));
              this.setState(
                {
                  inProgress: false,
                  errors,
                  isSaving: false
                },
                () => {
                  // this.props.getInvoices();
                }
              );
              this.getManualBillingDetails(
                this.state.invoice.order_number
              );
            } else {
              alertMessage(result.errors, "error", 10);
              this.setState({ inProgress: false, isSaving: false }, () => {
                if (!item.id) {
                  this.handleDeleteclick(index, itemType, orderNo, true);
                }
              });
            }
          }).then(() => {
            // call save and reapprove if in approval status
            if (invoice.status === "APPROVED") {
              this.handleSaveAndReapprove();
            }
          });

        } else {
          const orderInfo = invoice.order_info || {};
          const data = {
            new_invoice_lines: newInvoiceLines,
            remark: "",
            order_group_type: invoice.order_group_type,
            customer_order_id: typeObject.order_id || orderInfo.order_id || "",
            reference_id:
              invoice.order_group_type === "ORDER"
                ? invoice.customer_order_id
                : invoice.order_number,
            status: invoice.status,
            ...this.estimateApiParams(),
          };
          updateInvoiceLines(data).then((result) => {
            if (result.success) {
              alertMessage(I18n.t("messages.saved"));
              this.setState(
                {
                  inProgress: false,
                  errors,
                  isSaving: false
                },
                () => {
                  // this.props.getInvoices();
                }
              );
              this.getBillingDetails(
                this.state.invoice.customer_order_id
              );
            } else {
              alertMessage(result.errors, "error", 10);
              this.setState({ inProgress: false, isSaving: false }, () => {
                if (!item.id) {
                  this.handleDeleteclick(index, itemType, orderNo, true);
                }
              });
            }
          }).then(() => {
            // call save and reapprove if in approval status
            if (invoice.status === "APPROVED") {
              this.handleSaveAndReapprove();
            }
          });
        }
      }
    } else {
      this.setState({ isSaving: false }) 
    }
  };


  handleSave = () => {
    const invoice = {
      new_invoice_lines: [],
      remark: this.state.comments || "",
      reference_id:
        this.state.invoice.order_group_type === "ORDER"
          ? this.state.invoice.customer_order_id
          : this.state.invoice.order_number,
      order_group_type: this.state.invoice.order_group_type,
      status: this.state.invoice.status,
      ...this.estimateApiParams(),
    };
    updateInvoice(invoice).then((result) => {
      if (result.success) {
        alertMessage(I18n.t("messages.saved"));
        this.setState(
          {
            inProgress: false,
            comments: "",
          },
          () => {
            // this.props.getInvoices();
          }
        );
        this.closeRemarksModal();
        this.refreshDetails();
      } else {
        alertMessage(result.errors, "error", 10);
        this.setState({ inProgress: false });
      }
    });
  };

 hasAllChargesEmpty = (chargesLines = []) => {
  const allCharges = chargesLines.flatMap(({ label, data }) =>
    data.flatMap(({ price_list, individual_lines }) => {
      const fromPriceList = price_list || [];
      const fromIndividualLines = label !== "Accessorial" ? (individual_lines || []) : [];
      return [...fromPriceList, ...fromIndividualLines];
    })
  );

  const hasCharges =
    allCharges.length > 0 &&
    allCharges.some((item) => !isEmpty(item.id));

  return hasCharges;
};


// Helper to check for unsaved lines
getUnsavedChargesMessages = (chargesList = []) => {
  const orderMap = {};

  chargesList.forEach(({ label, data }) => {
    data.forEach(({ order_number, price_list = [], individual_lines = [] }) => {
      const linesToCheck = [
        ...price_list,
        ...(label !== "Accessorial" ? individual_lines : []),
      ];

      const hasUnsaved = linesToCheck.some((item) => !item?.id || item?.isEditing);

      if (hasUnsaved) {
        if (!orderMap[order_number]) {
          orderMap[order_number] = [];
        }
        orderMap[order_number].push(label);
      }
    });
  });

  return Object.entries(orderMap).map(
    ([orderNo, chargeTypes]) =>
      `Order ${orderNo} has unsaved ${chargeTypes.join(", ")} charges`
  );
};

  validateTemplateTypeFields = () => {
    const { ikeaChargesrecord = [] } = this.state;

    const ikeaFieldErrorMap = {
      gl_code: "GL code can't be empty",
      invoice_name: "Description can't be empty",
      invoice_quantity: "Units can't be empty",
      invoice_value: "Invoice amount can't be empty",
      unit_price: "Unit price can't be empty",
      location_id: "Order Type can't be empty",
    };

    const errors = [];

    Object.entries(ikeaFieldErrorMap).forEach(([field, errorMessage]) => {
      if (ikeaChargesrecord.some(record => isEmpty(record?.[field]))) {
        errors.push(errorMessage);
      }
    });

    return errors;
  };


  handleValidation = () => {
    const { invoice = {} } = this.state;
    const isTemplateZoneBilling = invoice?.order_group_type === "TEMPLATE";

    if (isTemplateZoneBilling) {
      const errors = this.validateTemplateTypeFields(); // handles ikeaChargesrecord internally

      if (errors.length > 0) {
        this.setState({
          isLoading: false,
          chargesLinesWarning: errors.join(", "),
          openWarningModal: true,
        });
        return true;
      }

      return false;
    }

    // For non-TEMPLATE orders
    const {
      accessorial_charges = [],
      transportation_charges = [],
      adjustment_charges = [],
      fuel_surcharges = [],
    } = invoice;

    const messages = this.getUnsavedChargesMessages([
      { label: "Transportation", data: transportation_charges },
      { label: "Fuel surcharges", data: fuel_surcharges },
      { label: "Accessorial", data: accessorial_charges },
      { label: "Adjustment", data: adjustment_charges },
    ]);

    if (messages.length > 0) {
      this.setState({
        isLoading: false,
        chargesLinesWarning:
          messages.join("\n") + "\nPlease save them before saving the bill.",
        openWarningModal: true,
      });
      return true; // Validation failed
    }

    return false; // Validation passed
  };

  saveInvoiceForm = () => {
    const { invoice } = this.state;
    const {
      accessorial_charges = [],
      transportation_charges = [],
      adjustment_charges = [],
      fuel_surcharges = [],
    } = this.state.invoice || {};

    this.setState({ isLoading: true });

    // Part 1 validation: Check if any unsaved lines exist either a new chregs lines or while editing existing chrages lines
      const messages = this.getUnsavedChargesMessages([
        { label: "Transportation", data: transportation_charges },
        { label: "Fuel surcharges", data: fuel_surcharges },
        { label: "Accessorial", data: accessorial_charges },
        { label: "Adjustment", data: adjustment_charges },
      ]);

      // Show combined message if any unsaved types found
      if (messages.length > 0) { 
        this.setState({
          isLoading: false,
          chargesLinesWarning: messages.join("\n") + "\nPlease save them before saving the bill.",
          openWarningModal: true
       });
        return;
      }

    // Part 2 validation: check if any order have all empty charges lines
      const hasChargeLine = this.hasAllChargesEmpty([
        { label: "Transportation", data: transportation_charges },
        { label: "Fuel_surcharges", data: fuel_surcharges },
        { label: "Accessorial", data: accessorial_charges },
        { label: "Adjustment", data: adjustment_charges },
      ]);
      if (!hasChargeLine) {
        this.setState({
          isLoading: false,
          chargesLinesWarning: "Please add charges lines",
          openWarningModal: true,
        });
        return;
      }

      const data = {
        invoice: this.state.invoice,
        account_id: this.state.invoice.account_details.id,
        order_group_type: this.state.invoice.order_group_type,
        invoice_number: this.state.invoice.order_number,
        status: this.state.invoice.status,
        reference_id:
          this.state.invoice.order_group_type == "GROUP"
            ? this.state.invoice.order_number
            : this.state.invoice.customer_order_id,
        billing_check_lists: {
          paper_work_done: this.state.isPaperWorkDone ? "true" : "false"        
        }
      };
      saveInvoiceDetailsForm(data).then((result) => {
        if (result.success) {
          alertMessage(I18n.t("messages.saved"), 10);
          // this.props.getInvoices();
          if (invoice.order_group_type === "MANUAL") {
            this.getManualBillingDetails(this.state.invoice.order_number);
          } else {
            this.getBillingDetails(this.state.invoice.customer_order_id);
          }
        } else {
          renderAlertMessage(result.errors)
        }
      }).finally(() => {
        this.setState({ isLoading: false });
      });      
  };

  saveTemplateZoneBilling = () => {
    const { invoice, ikeaChargesrecord } = this.state;
    const { transportation_charges = [], status} = this.state.invoice || {};

    if (transportation_charges[0]?.price_list?.length === 0 && status !== "APPROVED") {
      this.setState({
        isLoading: false,
        chargesLinesWarning: "Please add charges lines",
        openWarningModal: true,
      });
    } else if (
      ikeaChargesrecord.some(
        (record) =>
          isEmpty(record.gl_code) ||
          isEmpty(record.invoice_name) ||
          isEmpty(record.invoice_quantity) ||
          isEmpty(record.invoice_value) ||
          isEmpty(record.unit_price) ||
          isEmpty(record.location_id)
      )
    ) {
      const errors = this.validateTemplateTypeFields();

      // Display errors in alert or handle them as needed
      if (errors.length > 0) {
        this.setState({
          isLoading: false,
          chargesLinesWarning: errors.join(","),
          openWarningModal: true,
        });
      }
    } else {
      this.setState({
        newIkeaChargesRecord: [],
        isLoading: true,
      });
      const data = {
        new_invoice_lines: ikeaChargesrecord?.length
          ? ikeaChargesrecord.map((item) => ({
              ...item,
              invoice_type: "Transportation",
            }))
          : [],
        remarks: invoice.remarks,
        order_group_type: "TEMPLATE",
        customer_order_id: invoice.customer_order_id,
        status: this.state.invoice.status,
        reference_id:
          this.state.invoice.order_group_type == "GROUP"
            ? this.state.invoice.order_number
            : this.state.invoice.customer_order_id,
      };
      saveTemplateZoneForm(data).then((result) => {
        if (result.success) {
          alertMessage(I18n.t("messages.saved"), 10);
          // this.props.getInvoices();
          if (invoice.order_group_type === "MANUAL") {
            this.getManualBillingDetails(this.state.invoice.order_number);
          } else {
            this.getBillingDetails(this.state.invoice.customer_order_id);
          }
        } else {
          renderAlertMessage(result.errors);
        }
      }).finally(() => {
        this.setState({ isLoading: false });
      });
    }
  }


  handleSaveAndReapprove = async (selectedInfo = selectedInfo ? selectedInfo : this.state.selectedInfo, calledFromButton = false) => {
    this.setState({ isRepproveLoading : true });
    const {
      accessorial_charges = [],
      transportation_charges = [],
      adjustment_charges = [],
      fuel_surcharges = [],
    } = this.state.invoice || {};

    const selectedIds = selectedInfo?.selectedKeys
      ? _.compact(selectedInfo.selectedKeys)
      : []
      try {
        // Build list of unsaved charge types calidation check
        const messages = this.getUnsavedChargesMessages([
          { label: "Transportation", data: transportation_charges },
          { label: "Fuel surcharges", data: fuel_surcharges },
          { label: "Accessorial", data: accessorial_charges },
          { label: "Adjustment", data: adjustment_charges },
        ]);

        // Show combined message if any unsaved types found
        if (calledFromButton && messages.length > 0) {
          this.setState({
            isLoading: false,
            chargesLinesWarning: messages.join("\n") + "\nPlease save them before saving the bill.",
            openWarningModal: true
        });
          return;
        }

        const payload = {
          customer_order_ids: selectedIds,
          organization_id: userStore.getStateValue("selectedOrg"),
          invoice_number: this.state.invoice.order_number
        };
        if (this.state.is_pickup_by_driver === "true") {
          payload.is_pickup_by_driver = "true";
          payload.pickup_order_driver_id = this.state.pickup_order_driver_id;
          payload.pickup_order_amount = this.state.pickup_order_amount;
        }
        let response = {};
        response = await reapproveBillings(payload);
        if (response.success) {
          const result = response?.invoices ? response.invoices : {};
          const successMessage = result?.message
            ? result.message
            : I18n.t("messages.saved");
          //  typeof onSave === 'function' && onSave(I18n.t('messages.saved'))
          alertMessage(successMessage);
          this.handleApproveSuccess("APPROVED")
          // resetValues();
        } else {
          throw new Error(response.errors[0]);
        }
      } catch (error) {
        alertMessage(error.message, "error", 10);
      } finally {
        this.setState({ isRepproveLoading: false });
      }
  };

  handleReapprove = () => {
    if(this.state.invoice.status === "APPROVED")
    this.handleSaveAndReapprove();
  };

  handleApproveSuccess = (status) => {
    this.setState(
      {
        isApproved: true,
        loading: false,
        invoice: Object.assign({}, this.state.invoice, { status }),
        enableHide: true,
      },
      () => {
        if (this?.props?.callFrom === "order") {
          const transportation_charges =
            _.get(this.state, "invoice.transportation_charges", []) || [];
          const orderNumbers = transportation_charges.map(order => order.order_number);
          if (this.props.onUnmount) {
            this.props.onUnmount(orderNumbers, this.state.isApproved);
          }
        }
        // this.props.onChange("currentInvoice", this.state.invoice);
      }
    );
  };

  handleStatusChange = (status) => {
    const { invoice } = this.state;
    const {
      accessorial_charges = [],
      transportation_charges = [],
      adjustment_charges = [],
      fuel_surcharges = [],
    } = this.state.invoice || {};

    if (
      (accessorial_charges[0].price_list.length === 0 &&
        transportation_charges[0].price_list.length === 0 &&
        adjustment_charges[0].price_list.length === 0) ||
      (accessorial_charges[0].price_list.find((acc) => acc.id) === undefined &&
        transportation_charges[0].price_list.find((acc) => acc.id) ===
          undefined &&
        adjustment_charges[0].price_list.find((acc) => acc.id) === undefined)
    ) {
      alertMessage("Please add and save invoice line", "error", 10);
    } else {
      this.setState({
        loading: true,
      });
      const data = {
        // order_id: id,
        order_id:
          this.state.invoice.order_group_type === "ORDER"
            ? this.state.invoice.customer_order_id
            : this.state.invoice.order_number,
        order_group_type: this.state.invoice.order_group_type,
        status,
      };
      changeInvoiceStatus(data).then((result) => {
        if (result.success) {
          alertMessage(I18n.t("messages.processed"), 10);
          this.setState(
            {
              loading: false,
              invoice: Object.assign({}, this.state.invoice, { status }),
            },
            () => {
              // this.props.onChange("currentInvoice", this.state.invoice);
            }
          );
        } else {
          renderAlertMessage(result.errors)
          this.setState({
            loading: false,
          });
        }
      });
    }
  };

  // componentWillReceiveProps(nextProps) {
  //   if (!_.isEqual(nextProps.currentInvoice, this.state.invoice)) {
  //     this.setState(
  //       {
  //         invoice: nextProps.currentInvoice,
  //       },
  //       () => {
  //         this.setInvoiceLos();
  //         this.setSelectedInfo();
  //       }
  //     );
  //   }
  // }

  setInvoiceLos = () => {
    const invoiceLos = {};
    const totalOrders = this.getInvoiceOrders();
    const { invoice } = this.state;

    totalOrders.forEach((order) => {
      invoiceLos[order.order_id] = [];
    
      if (_.get(this.props, 'organizationSettings.individual_stop_los_order_level', '') == "true") {
        if (order.type_of_order === "MS") {
          invoiceLos[order.order_id] = invoice.orders_info.map((invOrder) => ({
            location_id: invOrder.locations?.[0]?.location_id,  // pick first location
            level_of_service_code: invOrder.level_of_service,
          }));
        } else {
          order?.locations?.forEach((loc) => {
            invoiceLos[order.order_id].push({
              location_id: loc.location_id,
              level_of_service_code: loc.level_of_service_code,
            });
          });
        }
      } else {
        order?.locations.forEach(loc => {
          invoiceLos[order.order_id].push({
            location_id: loc.location_id,
            level_of_service_code: loc.level_of_service_code,
          });
        })
      }

    });
    this.setState({
      invoiceLos,
    });
  };

  closeRemarksModal = () => {
    this.setState({
      showRemarks: false,
    });
  };

  openApprovalReasonModal = () => {
    if (this.props.embeddedInBulk) {
      const description = (this.props.bulkApprovalDescription || "").trim();
      this.handlePendingPaperworkApprove(description);
      return;
    }
    this.setState({ approvalReasonModalVisible: true });
  };

  closeApprovalReasonModal = () => {
    this.setState({ approvalReasonModalVisible: false });
  };

  handlePendingPaperworkApprove = (description) => {
    this.setState({ approveInProgress: true, approvalReasonModalVisible: false });
    const totalOrders = this.getInvoiceOrders();
    const customer_order_ids = totalOrders.map((order) => order.order_id).filter(Boolean);
    const organization_id = userStore.getStateValue("selectedOrg");
    const data = {
      organization_id,
      customer_order_ids,
      ...(description ? { description } : {}),
    };

    approveBillingPaperwork(data)
      .then((result) => {
        if (result.success) {
          alertMessage(result.message || "Paperwork approved successfully!");
          if (this.props.embeddedInBulk && this.props.onPendingApproveSuccess) {
            this.props.onPendingApproveSuccess();
          } else {
            if (this.props.handleSuccess) {
              this.props.handleSuccess();
            }
            if (this.props.closeModal) {
              this.props.closeModal();
            }
          }
        } else {
          renderAlertMessage(result.errors || result.message || "Approval failed");
        }
      })
      .catch((error) => {
        console.error("Error approving paperwork:", error);
        alertMessage(error.message || "An error occurred during approval", "error");
      })
      .finally(() => {
        this.setState({ approveInProgress: false });
      });
  };

  regenerateInvoiceWithLos = (invoiceLos, cb = null, isReset = false) => {
    this.setState({ isLoading : true });
    const data = {
      ...(isReset ? { is_reset: true } : {}),
      ...this.estimateApiParams(),
      organization_id: userStore.getStateValue("selectedOrg"),
      fmp_order_id: getFMPOrderFromInvoice(this.state.invoice),
      account_id: this.state.invoice.account_details.id,
      orders_info: Object.keys(invoiceLos).map((rec) => {
      const nonNoneLos = _.get(_.find(invoiceLos[rec], function(o) { return o.level_of_service_code !== 'NONE' }), "level_of_service_code", "") || "";
      return ({
        customer_order_id: rec,
        los_code: nonNoneLos || _.get(invoiceLos[rec], "[0].level_of_service_code", "") || "",
        locations_info: invoiceLos[rec],

      })
    }),
    };
    message.loading({
      key: "generate",
      content: isReset ? I18n.t("messages.generating") : I18n.t("messages.resetting"),
    });
    regenerateInvoiceWithNewLos(data)
      .then((result) => {
        if (result.success) {
          message.success({
            key: "generate",
            content: I18n.t("messages.generated"),
          });
          const currentInvoice = this.handleInvoiceResponse(
            result,
            this.state.invoice.customer_order_id
          );
          this.setState(
            {
              // result.orders.customer_order
              invoice : currentInvoice,
              regenerateProgress: false,
            },
            () => {
              // this.getBillingOrders();
              this.getBillingDetails(this.state.invoice.customer_order_id);
              if (this.state.invoice.status === "APPROVED") {
                cb();
              }
            }
          );
        } else {
          message.error({
            key: "generate",
            content: result.errors.join(","),
          });
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  reGenerate = () => {
    this.props.handleIsLosChanged(false);
    this.regenerateInvoiceWithLos(this.state.invoiceLos , this.handleSaveAndReapprove);
    // this.getBillingDetails(this.state.invoice.customer_order_id)
  };

  onReset = () => {
    this.props.handleIsLosChanged(false);
    this.regenerateInvoiceWithLos(this.state.invoiceLos , this.handleSaveAndReapprove, true);
  }

  // Params the backend expects on every Estimate-tab billing request so it can
  // branch correctly: a source tag and is_for_invoice_quote derived from the
  // Sync Estimation & Billing org rule (sync ON => real billing "false",
  // sync OFF => quote "true"). Returns {} off the Estimate tab so the Billing
  // screen's payloads/URLs are unchanged.
  estimateApiParams = () => {
    if (!this.props.fromEstimate) return {};
    // Prefer the value the Estimate wrapper computed from context; fall back to
    // reading the org rule off userContext when available.
    const syncOn =
      _.get(this.props, "userContext.orgRules.org_billing_rules.sync_est_and_billing") === "true";
    const is_for_invoice_quote =
      this.props.estimateIsForInvoiceQuote || (syncOn ? "false" : "true");
    return { source: "ESTIMATE", is_for_invoice_quote };
  };

  // Estimate tab "Recalculate" (replaces Regenerate there): mirror the legacy
  // estimate action — re-run the billing CREATE then reload the quote (OQIND).
  // is_for_invoice_quote follows the Sync Estimation & Billing org rule.
  recalculateEstimate = () => {
    const id = this.state.activeRecordId;
    if (!id) return;
    const current_date = new Date().toISOString().split("T")[0];
    this.setState({ isLoading: true });
    saveInvoice({ order_id: id, current_date, ...this.estimateApiParams() })
      .then((result) => {
        if (result && result.errors) {
          renderAlertMessage(result.errors);
        }
        this.getBillingDetails(id);
      })
      .catch(() => this.setState({ isLoading: false }));
  };

  showRemarksModal = () => {
    this.setState({
      showRemarks: true,
    });
  };

  renderRemarks = () => (
    <BaseModal
      title={I18n.t("invoices.add_remark")}
      onCancel={() => this.closeRemarksModal()}
    >
      <div>
        <TextArea
          rows={4}
          placeholder={I18n.t("invoices.remarks")}
          className="sop-form-textArea"
          value={this.state.comments}
          onChange={(e) => this.handleRemarksChange("comments", e.target.value)}
        />
        <div style={{ textAlign: "center" }}>
          <Button onClick={this.closeRemarksModal}>
            {I18n.t("general.close")}
          </Button>
          <Button
            onClick={this.handleSave}
            disabled={this.state.disableRemarksButton || this.state.isOnHold}
            className="assignDriver"
            style={{ margin: 10 }}
            type="primary"
            loading={this.state.loading}
          >
            {I18n.t("general.save")}
          </Button>
          <Typography.Paragraph>
            {" "}
            <b>
              {" "}
              <span className="textRed">Note</span>{" "}
            </b>{" "}
            : Remarks should be minimum of 10 characters.{" "}
          </Typography.Paragraph>
        </div>
      </div>
    </BaseModal>
  );

  handleRemarksChange = (element, value) => {
    if (value !== "" && value.length > 2) {
      this.setState({
        [element]: value,
        disableRemarksButton: false,
      });
    } else {
      this.setState({
        [element]: value,
        disableRemarksButton: true,
      });
    }
  };
  showAddOrdersModal = () => {
    this.setState({
      showAddOrders: true,
    });
  };

  getEmailSubject = async () => {
    const orderNumbers = this.state.invoice.transportation_charges.map(
      (charge) => charge.order_number
    );
    const orderIds = this.state.invoice.transportation_charges.map(
      (charge) => charge.order_id
    );
    const orderCount =
      orderNumbers.length > 1
        ? "_(" + (orderNumbers.length - 1) + "_more)"
        : "";
    const orgId = userStore.getStateValue("selectedOrg");

    const defaultSubject = orderNumbers?.length
      ? `${orderNumbers[0]} ${orderCount} ${"BILLING_PDF"}`
      : `${orderNumbers}`;

    const payload = {
      organization_id: orgId,
      order_id: orderIds[0],
      setting_name: "billing_email_subject",
    };

    try {
      const result = await getEmailSubjectLine(payload);

      if (result.success) {
        const emailSubject = result?.subject ? result.subject : defaultSubject;
        this.setState({
          subject: emailSubject,
        });
      } else {
        this.setState({
          subject: defaultSubject,
        });
        alertMessage(result.errors[0], "error", 10);
      }
    } catch (error) {
      console.error("Error fetching email subject:", error);
    } finally {
      this.setState({
        showEmailModal: true,
        description: "Please find the billing attachment",
      });
    }
  };

  showEmailModal = () => {
    // const orderNumbers = this.state.invoice.transportation_charges.map(charge => charge.order_number);
    // const orderCount = orderNumbers.length > 1 ? ('+${orderNumbers.length - 1}') : '';
    // const orderCount = orderNumbers.length > 1 ? ('_(' + (orderNumbers.length - 1) + '_more)') : ''
    this.getEmailSubject()
    this.getEmails();
    // this.setState({
    //   showEmailModal: true,
    //   subject: orderNumbers?.length ? `${orderNumbers[0]} ${orderCount} ${'BILLING_PDF'}` : `${orderNumbers}`,
    //   description: "Please find the billing attachment",
    // });
    // this.getEmails();
  };

  _renderHeaderInfo = ({isLocked,isAdjusted,hasConsolidatedOrders,selectedInfo}) => {
    const { invoice, showActions } = this.state;
    const isReadyOnly = invoice.status === "PAYMENT_CONFIRMED";
    const isDriverSettlementApproved = this.state.isDriverSettlementApproved
    const isFromPendingBucket = this.isFromPendingBucket();
    // const isLocked = false;
    // const DriverSettlementApproved = true;
    // const hasConsolidatedOrders = true;

    return (
      <InvoiceHeader
        fromEstimate={this.props.fromEstimate}
        invoice={invoice}
        isReadyOnly={isReadyOnly}
        showActions = {showActions}
        logoUrl={this.state.logo}
        consolidatedOrderNumbers = {this.state.consolidatedOrderNumbers}
        levelOfServices={this.state.levelOfServices || []}
        handleOnChange={this.handleStateOnChange}
        currentLos={this.state.currentLos}
        reGenerate={this.reGenerate}
        showAddOrdersModal={this.showAddOrdersModal}
        showAddOrders={!isFromPendingBucket}
        isLocked={isLocked || this.state.isOnHold}
        isAdjusted={isAdjusted}
        isConsolidated = {hasConsolidatedOrders}
        DriverSettlementApproved = {isDriverSettlementApproved}
        // getInvoices={this.props.getInvoices}
        showEmailModal={this.showEmailModal}
        isSendingMail={this.state.isSendingMail}
        selectedInfo={selectedInfo}
        isInvoiceLocked={ this.state.isInvoiceLocked }
        isLoading={this.state.isLoading}
        driversList = {this.state.driversList}
        retrivePreviewDetails={this.retrivePreviewDetails}
        handleReset={ this.onReset }
      />
    );
  };

  handleEditOrderClick = (id) => {
    this.setState(
      {
        selectedOrderId: id,
      },
      () => {
        fetchOrderDetails(id).then((result) => {
          if (result.success) {
            const currentOrder =
              result.orders.length > 0 ? _.find(result.orders, { id: id }) : {};
            if (!currentOrder.id) {
              currentOrder.id = id;
            }
            this.setState(
              {
                currentOrder,
              },
              () => {
                this.setState({ editForm: true });
              }
            );
          }
        });
      }
    );
  };


  closeEditFormModal = () => {
    this.setState({
      editForm: false,
      currentOrder: {},
    });
  };


  renderTitle = (order) => {
    const { invoice, config, showActions } = this.state;
    const { showisConsolidation } = this.props;
    const isLocked = order.is_locked == "true" || this.state.isOnHold;
    // const isAdjusted = order.is_adjusted == 'true';
    const isAdjusted = false;
    const isConsolidated = order.is_consolidated === 'true';
    return (
      <Fragment>
        {invoice.order_group_type !== "MANUAL" && (
          <Row type="flex">
            {
              showisConsolidation && isConsolidated  &&
              <Col>
                <ConsolidationButton
                 isAdjusted={isAdjusted}
                  consolidation_no={order.consolidation_number}
                  consolidate_order_id={order.consolidated_id}
                    handleSuccess={ () => this.getBillingDetails(order.order_id) }
                  displayType="icon"
                  className={"marginLeft10"}
                  label={I18n.t("consolidation.consolidation_details")}
                  orders={[order]}
                  key={`conslodiate${order.order_id}`}
                  styleObj={{ marginRight : 7}}
                />
              </Col>
            }
            <Col>
              <CustomerOrderDetails
              isAdjusted={isAdjusted}
              refreshCallback={() =>  this.getBillingDetails(this.state.activeRecordId)}
                isOnHold={this.state.isOnHold}
              key={`bill${order.order_id}`}
              order_no={order.order_no}
              order={{
                id: order.order_id,
                customer_order_number: order.order_no,
                is_smp_applied: order.is_smp_applied === true,
                smp_stamp: order.smp_stamp === "true" ? "true" : "false",
              }}
              showEdit={ this.state.currentOrderGroupType !== "TEMPLATE" && !isLocked }
              disableOrderClick={this.isFromPendingBucket()}
              editClick={ () => this.handleEditOrderClick(order.order_id) }
              applyFmp={ () => this.applyFmp(order.order_id) }
              showSMP={ !isLocked }
              showFMPLink={ !isLocked && config[ "second_price_type" ] !== "ITEM" }
              style={ { fontSize: 18 } }
              applySmp={ () => this.applySmp(order.order_id) }
              showApplySMP={ !isLocked && invoice.transportation_charges.length === 1 }
              screenFrom="billing"
            />
            </Col>
            {/* <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={() =>
                this.props.handleOrderDetailsViewClick(order.order_id)
              }
            >
              {`#${order.order_no}`}
            </span> */}
            {/* {this.renderFMP(order)} */}
          </Row>
        )}
      </Fragment>
    );
  };

  renderApplySMP = (order) => {
    return (
      <Fragment>
        {order.smp_stamp === "true" && !order.is_smp_applied && (
          <Popconfirm
            placement="topRight"
            title={I18n.t("general.are_you_sure")}
            onConfirm={() => this.applySmp(order.order_id)}
          >
            <Button
              type="primary"
              size="small"
              className="textBold fontSize12 "
              style={{ marginTop: 1 }}
              icon='check-circle'
            >
              Apply SMP
            </Button>
          </Popconfirm>
        )}
      </Fragment>
    );
  };

  renderFMP = (order) => {
    return (
      <Fragment>
        {" "}
        {order.smp_stamp === "true" && order.is_smp_applied && (
          <Popconfirm
            placement="topRight"
            title={I18n.t("general.are_you_sure")}
            onConfirm={() => this.applyFmp(order.order_id)}
          >
            <Button
              type="primary"
              size="small"
              className="textBold fontSize12 "
              style={{ marginTop: -2 }}
            >
              Apply&nbsp;
              {showFMP()}
            </Button>
          </Popconfirm>
        )}{" "}
      </Fragment>
    );
  };

  initialChargeValues = (invoice) => {
    if (isEmpty(invoice.transportation_charges)) {
      invoice.transportation_charges = [];
    }
    if (isEmpty(invoice.fuel_surcharges)) {
      invoice.fuel_surcharges = [];
    }
    if (isEmpty(invoice.accessorial_charges)) {
      invoice.accessorial_charges = [];
    }
    if (isEmpty(invoice.adjustment_charges)) {
      invoice.adjustment_charges = [];
    }
    return invoice;
  };

  removeGroupedOrder = (order_id, invoice) => {
    const orgId = userStore.getStateValue("selectedOrg");
    const payload = {
      organization_id: orgId,
      customer_order_id: order_id,
      order_group_type: invoice.order_group_type,
      fmp_order_id: getFMPOrderFromInvoice(invoice),
    };
    this.setState({ isRemovingGroupOrder: true });
    removeOrderFromBillingGroup(payload)
      .then((result) => {
        if (result.success) {
          this.refreshDetails();
          alertMessage(I18n.t("messages.removed_successfully"), 10);
        } else {
          renderAlertMessage(result.errors)
        }
      })
      .finally(() => {
        this.setState({ isRemovingGroupOrder: false });
        // this.props.getInvoices();
      });
  };

  getInvoiceOrders = () => {
    const { invoice } = this.state;

    // const isAdjusted = invoice.is_adjusted;
    const isAdjusted = 'false';

    const orders =
      invoice?.transportation_charges &&
      invoice.transportation_charges.length > 0
        ? invoice.transportation_charges.sort((a,b)=>a.order_number?a.order_number.localeCompare(b.order_number,{numeric:true}):-1)
          .map((order) => ({
            order_id: order.order_id,
            order_no: order.order_number,
            is_smp_applied: order.is_smp_applied,
            hawb: order.hawb,
            mawb: order.mawb,
            level_of_service: order.level_of_service,
            driver_notes: order.driver_notes,
            is_locked: order.is_locked,
            smp_stamp: order.smp_stamp,
            is_consolidated: order.is_consolidated,
            is_driver_settlement_approved : order.is_driver_settlement_approved,
            consolidated_id: order.consolidated_id,
            consolidation_number: order.consolidation_number,
            locations: _.sortBy((order.locations || []), "location_sequence"),
            all_locations: _.sortBy((order.all_locations || []), "location_sequence"),
            type_of_order: order.type_of_order,
            instructions : order.instructions || {},
            weight: order.order_weight,
            weight_in_kgs: order.weight_in_kgs,
            lbs_weight: order.lbs_weight,
            kgs_weight: order.kgs_weight,
            actual_weight: order.actual_weight,
            actual_weight_in_kgs: order.actual_weight_in_kgs,
            quantity : order.order_qty,
            surface_area : order.surface_area,
            pallets : order.pallets,
            related_order : order.related_order,
            is_adjusted: isAdjusted,
            weight_units: order.weight_units,
            cbm_volume: order.cbm_volume,
            is_prepaid: order.is_prepaid === true,
            prepaid_amount: order.prepaid_amount,
          }))
        : [];
    return orders;
  };

  searchBar = (e) => {
    const value = e.target.value
    const billingActivities = this.state.billingActivitiesList;

    if (!_.isEmpty(_.trim(value))) {
      const lowerValue = _.lowerCase(_.trim(value));
      const filteredActivities = billingActivities.filter(item => {
        const activityValues = Object.values(item);
        return activityValues.some(val => _.lowerCase(val).includes(lowerValue));
      });

      this.setState({
        filteredBillingActivitiesList: filteredActivities
      });
    } else {
      this.setState({
        filteredBillingActivitiesList: billingActivities
      });
    }
  }
  filterOrderNos = (selectedTags) => {
    const {filterOrderIds} = this.state;
    const updatedTags = selectedTags;
    const orderIds = [];
    if (selectedTags.length === 0 && this.state.filteredOrdersForActivities.length === 1) {
      return;
    }
      // Iterate over each tag in updatedTags
      updatedTags.forEach(tag => {
        // Find the corresponding object in filterOrderIds
        const matchingOrder = filterOrderIds.find(order => order.order_number === tag);

        // If a matching object is found, push its orderId into the orderIds array
        if (matchingOrder) {
            orderIds.push(matchingOrder.order_id);
        }
    });
    this.setState({ filteredOrdersForActivities: updatedTags }, () => {
        const parms ={
            organization_id: userStore.getStateValue("selectedOrg"),
            customer_order_ids: orderIds
        };
        getBillingActivities(parms).then(result => {
          if (result.success) {
            this.setState({ billingActivitiesList: result.data.activities, filteredBillingActivitiesList: result.data.activities, })
          }
          else {
            renderAlertMessage(result.errors);
          }
        })
    });
}

  
  applyFmp = (orderId) => {
    const account = this.state.invoice.account_details
      ? this.state.invoice.account_details
      : {};
    const data = {
      organization_id: userStore.getStateValue("selectedOrg"),
      account_id: account?.id ? account.id : "",
      fmp_order_id: orderId,
    };
    this.setState({
      isLoading: true,
    });
    applyFMP(data).then((result) => {
      if (result.success) {
        this.setState({
          isLoading: false,
        });
        const msg = result.message ? result.message : I18n.t("messages.saved");
        this.refreshDetails();
        // this.props.getInvoices();
        alertMessage(msg, 10);
      } else {
        this.setState({
          isLoading: false,
        });
        renderAlertMessage(result.errors)
      }
    });
  };

  applySmp = (orderId) => {
    const data = {
      customer_order_id: orderId,
    };
    this.setState({
      isLoading: true,
    });
    applySMP(data).then((result) => {
      if (result.success) {
        this.setState({
          isLoading: false,
        });
        const msg = result.message ? result.message : I18n.t("messages.saved");
        this.refreshDetails();
        // this.props.getInvoices();
        alertMessage(msg, 10);
      } else {
        this.setState({
          isLoading: false,
        });
        alertMessage(result.errors, "error", 10);
      }
    });
  };

  navigateToBilling = () => {
    this.props.history.replace("/billing");
  }


  goToTab = (key) => {
    this.setState({
      activeKey: key,
    });

    if (key === 'activities') {
      this.setState({ isLoading: true })
      this.setState({filteredOrdersForActivities:this.state.invoice.transportation_charges.map((orders) => orders.order_number)})
      this.setState({filterOrderIds : this.state.invoice.transportation_charges})
      const params = {
        organization_id: userStore.getStateValue("selectedOrg"),
        customer_order_ids: this.state.invoice.transportation_charges.map((orderIds) => orderIds.order_id)
      }
      getBillingActivities(params).then(result => {
        if (result.success) {
          this.setState({ billingActivitiesList: result.data.activities, filteredBillingActivitiesList: result.data.activities, })
        }
        else {
          renderAlertMessage(result.errors);
        }
      }
      ).finally(() => {
        this.setState({ isLoading: false })
      })
    }

  };


  handleOrderSaveSuccess = (
    callbackMessage,
  ) => {
    alertMessage(callbackMessage);
    this.getBillingDetails(this.state.invoice.customer_order_id);
    this.closeEditFormModal();
  };
  

  updateDriverDetails = (updated_driver_info) => {
    this.setState({
      invoice : {
        ...this.state.invoice,
        order_driver_details : updated_driver_info
      }
    })

  }

  trimDateFromHawb = (hawb) => {
    // Remove mm.dd or mm.dd.yyyy from the hawb
    const match = hawb.match(/(\d{2}\.\d{2}(?:\.\d{4})?)/);
    return match ? hawb.replace(match[ 0 ], "").trim() : hawb;
  }

  retrivePreviewDetails = (url, orderFileName) => {
    this.setState(
      {
        blobUrl: url,
        fileName: orderFileName,
      },
    );
  };  

handleLineExpand = (expanded, record, section, itemType) => {
  if (!expanded) {
    this.setState((prevState) => ({
      expandedRowIds: {
        ...prevState.expandedRowIds,
        [itemType]: '',
      },
      expandedChargeLineData: {
        ...prevState.expandedChargeLineData,
        [itemType]: [],
      },
    }));
    return;
  }

  const expandedData = (section?.individual_lines || []).map((item) => ({
    ...item,
    is_expanded_item: true,
  }));

  this.setState((prevState) => ({
    expandedRowIds: {
      ...prevState.expandedRowIds,
      [itemType]: record.id,
    },
    expandedChargeLineData: {
      ...prevState.expandedChargeLineData,
      [itemType]: expandedData,
    },
  }));
};

handleSubmit = () => {
  this.handleSaveReadyForBilling(this.state.confirmModalType === "pending" ? "PENDING" : "ON_HOLD");
};

  _renderHoldConfirmModal() {
  const { openConfirmModal, description, confirmModalLoading } = this.state;

    return (
      <React.Fragment>
        <Modal
          title={this.state.confirmModalType === "pending" ? "Rejection Reason" : "Hold Reason"}
          visible={openConfirmModal}
          onCancel={() => {
            if (!confirmModalLoading) {
              this.setState({ openConfirmModal: false });
            }
          }}
          className="ssc-modal"
          footer={[
            <Button_v2
              key="close"
              size="medium"
              onClick={() => {
                this.setState({ openConfirmModal: false });
              }}
              className="flat small-btn"
              text={I18n.t("general.close")}
              disabled={confirmModalLoading}
            />,
            <Button_v2
              key="create"
              size="medium"
              onClick={this.handleSubmit}
              className="small-btn raised"
              text="Submit"
              disabled={!description || !description.trim() || confirmModalLoading}
              loading={confirmModalLoading}
            />,
          ]}
          width={440}
        >
          <div className="ssc-modal-form">
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <div className="ssc-field">
                  <label className="ssc-field__label">
                    Notes / Reason <span style={{ color: 'red' }}>*</span>
                  </label>

                  <TextArea
                    rows={3}
                    placeholder={I18n.t("OrderStatus.description")}
                    className="sop-form-textArea"
                    value={description}
                    onChange={(e) =>
                      this.setState({ description: e.target.value })
                    }
                    disabled={confirmModalLoading}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
paperWorkChecked = async (checked) => {
  this.setState({isLoading: true})
  const { invoice } = this.state;
  // For group invoices the paper work applies to every order in the group, so
  // send all of the group's customer_order_ids (order_id is the customer order
  // id across billing calls). Fall back to the single invoice id when the order
  // list isn't available.
  const groupOrderIds = _.uniq(
    _.compact((this.getInvoiceOrders() || []).map((order) => order.order_id))
  );
  const customerOrderIds = groupOrderIds.length
    ? groupOrderIds
    : _.compact([_.get(invoice, "customer_order_id", null)]);
  try {
    const payload = {
      customer_order_ids: customerOrderIds,
      billing_check_lists: {
        paper_work_done: checked ? "true" : "false"
      }
    }
    const response = await savePaperWork(payload);
    if (response.success) {
      // Only reflect the new state once the server confirms the save.
      this.setState({ isPaperWorkDone: checked });
      alertMessage(I18n.t("messages.updated"), 10);
    } else {
      renderAlertMessage(response.errors);
    }
  }catch (error) {
    alertMessage(error.message, "error", 10);
  } finally {
  this.setState({isLoading: false})
  }
}

  render() {
    const roundOffDecimalPoints=Number(this.props.userContext.orgRules.org_billing_rules.round_off_decimals) || 2
    if (!this.state.invoice || Object.keys(this.state.invoice).length === 0){
      return <ContentOuter/>;
    }
    const invoice = this.initialChargeValues(this.state.invoice);
    let ikeaTotal = null;
    // use lodash to chain get
    const errorMessages = _.get(invoice, "error_messages", []);
    const errorLog = _.get(invoice, "error_log", []);
    const errors = errorMessages.length > 0 ? errorMessages : errorLog;
    const orderGroupType = invoice?.order_group_type;
    const BillingMethod = invoice?.transportation_charges[0]?.billing_template_method;
   
    let totalOrders = this.getInvoiceOrders();
    const { isRemovingGroupOrder } = this.state;
    const orderInfo = invoice.order_info || {};
    // const selectedInfo = {
    //   selectedKeys: [orderInfo.order_id],
    //   selectedRows: [{...orderInfo}],
    // };
    const selectedInfo = {
      selectedKeys: totalOrders.map((order) => order.order_id),
      selectedRows: [...totalOrders],
    };
    if (this.props.showFirstOne === true) {
      const filteredOrders = totalOrders.filter(
        (order) => order.order_id === orderInfo.order_id
      );
      totalOrders = [...filteredOrders];
    }
    const totalList = _.compact([
      ...invoice.transportation_charges,
      ...invoice.fuel_surcharges,
      ...invoice.accessorial_charges,
      ...invoice.adjustment_charges,
    ]);
    const isLocked = totalOrders.filter(order => order.is_locked == 'true').length > 0;
    // const isAdjusted = totalOrders.filter(order => order.is_adjusted == 'true').length > 0;
    const isAdjusted = false;
    // const DriverSettlementApproved = totalOrders.filter(order => order.is_driver_settlement_approved === 'true').length > 0;
    const hasConsolidatedOrders = totalOrders.filter(order => order.is_consolidated == 'true').length > 0;
    const isReadyOnly = isLocked || invoice.status === "PAYMENT_CONFIRMED";
    const isFromPendingBucket = this.isFromPendingBucket();
    const canManageFromOrder = this.props.callFrom !== "order" || checkAccessExistance("BILLING_FROM_ORDER");
    const showActions = (invoice.status === "READY_FOR_BILLING" || isFromPendingBucket) && canManageFromOrder;
    const showPendingManageActions = isFromPendingBucket;
    const showSavePrintActions = showActions || showPendingManageActions;
    const showAddNotes = true;
    const addNewChargeLine = ["APPROVED", "READY_FOR_BILLING", "PENDING"].includes(invoice.status) || isFromPendingBucket;   
    const orderDriversInfo = invoice.order_driver_details || []
    const isInvoiceApproved = invoice.status === "APPROVED"
    const headerTitle = `Billing ${this.state?.invoice?.order_info?.order_number ? `#${this.state.invoice.order_info.order_number}` : ""} `;
    const isTemplateZoneBilling = this.state?.invoice?.order_group_type === "TEMPLATE"

    const InstructionsDisplay = (data) => {
      const instructionsData = _.get(data, 'instructions', {
        notes: '',
        instructions_from_account_1: '',
        instructions_from_account_2: '',
      });
      const driverNotesData = _.get(data, 'driverNotes', '');
      return (
        <div>
          <Row>
            <Col span={ 24 }>
              <Typography.Text strong>Notes : </Typography.Text>
              <Typography.Text>
                {instructionsData?.notes?.replace(/<br\s*\/?>/gi, ' ')}
              </Typography.Text>
            </Col>
          </Row>
          
          {/* <Row>
            <Col span={ 24 }>
              <Typography.Text strong>Instructions 1:</Typography.Text>
              <Typography.Text>{ instructionsData.instructions_from_account_1 }</Typography.Text>
            </Col>
          </Row>
          <Row>
            <Col span={ 24 }>
              <Typography.Text strong>Instructions 2:</Typography.Text>
              <Typography.Text>{ instructionsData.instructions_from_account_2 }</Typography.Text>
            </Col>
            <Col span={ 24 }>
              <Typography.Text strong>Instructions 3:</Typography.Text>
              <Typography.Text>{ instructionsData.instructions_from_account_3 }</Typography.Text>
            </Col>*/}
          <Row>
            <Col span={ 24 }>
              <Typography.Text strong>Driver Notes : </Typography.Text>
              <Typography.Text>{ renderDriverNotes(driverNotesData) }</Typography.Text>
              </Col>
          </Row> 
        </div>
      );
    }

    const orderWeightUnits = this.props.accountUnitContext[invoice.account_details.code];
    const isKgs = orderWeightUnits === 'kgs';
    return (
      <div
        style={
          this.props.embeddedInBulk
            ? { height: "100%", overflow: "hidden" }
            : undefined
        }
      >
      <Spin
        spinning={this.state.isLoading || this.state.inProgress || this.state.noModifyLoading}
        wrapperClassName={this.props.embeddedInBulk ? "billing-form-spin-embedded" : undefined}
      >
      <div
        className="content-outer"
        style={
          this.props.embeddedInBulk
            ? { height: "100%", overflow: "hidden", minHeight: 0 }
            : undefined
        }
      >
        <div
          className="content indvOrderScreen"
          style={
            this.props.embeddedInBulk
              ? { height: "100%", overflow: "hidden", padding: 0, minHeight: 0 }
              : undefined
          }
        >
          {/* <Row className="page-header" justify="space-between" type="flex">
            <Col>
              <div>
                <span>
                  <span
                  // onClick={ () => this.gotoInvoices() }
                  >
                    { headerTitle }
                  </span>
                </span>
              </div>
            </Col>
            <Col>
            <div>
                <span>
                  <Icon
                    type="close"
                    onClick={ () => this.navigateToBilling() }
                  />{ " " }
                  &nbsp;
                  <span
                  >
                  </span>
                </span>
              </div>
            </Col>
          </Row> */}
          <div
            className="billing_indv"
            style={
              this.props.embeddedInBulk
                ? {
                    height: "100%",
                    maxHeight: "100%",
                    overflowY: "auto",
                    paddingBottom: 24,
                  }
                : undefined
            }
          >
              <Tabs
                data-testid="invoice-details-tabs"
                onChange={ this.goToTab }
                activeKey={ this.state.activeKey }
                size="small"
                type="card"
                tabBarStyle={ this.props.fromEstimate ? { display: "none" } : undefined }
                tabBarExtraContent={isLocked ? <Button type="danger" icon="lock" size="small">{I18n.t('general.locked')}</Button> : <Fragment />}
              >
                <TabPane tab={ I18n.t("general.details") } key="details">
              <div data-testid="details-screen-tab">

          <Row gutter={16}>
            {this.props.showHeaders !== false ? (
              <this._renderHeaderInfo isLocked={isLocked} isAdjusted={isAdjusted} hasConsolidatedOrders = {hasConsolidatedOrders} selectedInfo={selectedInfo}/>
            ) : (
              <div className="alignRight" />
            )}
            <div className="totalOrdersWrapper">
              {totalOrders.map((order, orderIndex) => {
                const locations = order?.locations || [];
                const allLocations = order?.all_locations || [];

                const transformedLocations = invoice?.orders_info
                  ?.filter(info => info.order_id === order.order_id)
                  .map(info => ({
                    order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
                    location_id: info.locations?.[0]?.location_id,
                    level_of_service_code: info.level_of_service,
                    location_sequence: info.segment_type === "PICKUP" ? 0 : 1,
                    loc_order_sequence: info.locations?.[0]?.location_sequence || ""
                  })) || [];
                const orderDataWithLocations = {
                  ...order,
                  locations: transformedLocations,
                  allLocations: allLocations,
                  type_of_order: order.type_of_order || invoice?.order_info?.type_of_order
                };
                const orderCharges = totalList.filter(
                  (items) => items.order_id === order.order_id
                );
                const totalPriceList = this.state.currentOrderGroupType === "TEMPLATE" ? [...this.state.ikeaChargesrecord] :_.flattenDeep(
                  _.compact(orderCharges.map((item) => [...item.price_list]))
                );
                const jobTotal = findNumberTotal(
                  totalPriceList,
                  "invoice_value",
                  null,
                  this.state.decimalPoints
                );
                ikeaTotal = jobTotal;
                const { invoiceLos, losConfig } = this.state;
                const driverObjects  = _.find(orderDriversInfo, { customer_order_id: order.order_id})

                const level_of_service_MS = () => {
                  const levelOfServices = this.state.levelOfServices || [];
                  const locations = _.flatMapDeep(
                    invoice?.orders_info?.map(info =>
                      info?.locations?.map(location => ({
                        order_type: info.segment_type === "PICKUP" ? "PICKUP" : "DELIVERY",
                        location_id: location.location_id,
                        level_of_service_code: info.level_of_service,
                        level_of_service_id: info.level_of_service_id,
                        loc_order_sequence: location.location_sequence || ""
                      })) || []
                    )
                  );
                  return (
                    _.sortBy(locations, 'loc_order_sequence').map((loc, index) => {
                      const losIndex = _.findIndex(locations, { location_id: loc.location_id })
                      const value = _.get(loc, 'level_of_service_code', '') || ''
                      const type_of_order = !isEmpty(order.related_order) ? 'M' : order.type_of_order;
                      const orderTypeLos = type_of_order && losConfig?.[type_of_order] ?
                        levelOfServices.filter(rec => losConfig[type_of_order].includes(rec.code)) :
                        [...levelOfServices]
                      return (
                        <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                          <Col>
                            <h4
                              style={{ marginBottom: 0 }}
                              className="textBold"
                            >
                              {`STOP ${index+1} ${I18n.t("los.short_form")} ( ${loc.order_type} ) :`}
                            </h4>
                          </Col>
                          <Col>
                            &nbsp;
                            {checkServiceExistance("LOSI") ? (
                              <Select
                                size="small"
                                value={
                                  value
                                }
                                showSearch
                                style={{ width: 180 }}
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) =>
                                  this.handleLosChange(
                                    order.order_id,
                                    losIndex,
                                    loc.location_id,
                                    e,
                                    loc.level_of_service_code
                                  )}
                                disabled={this.state.isInvoiceLocked || this.state.isOnHold || isAdjusted}
                                loading={this.state.losProgress}
                              >
                                <Select.Option key="LOS" value="">
                                  -- Select --
                                </Select.Option>
                                {orderTypeLos.map((los) => (
                                  <Select.Option
                                    key={los.code}
                                    value={los.code}
                                  >
                                    {los.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      )
                    })
                  )
                }

                return (
                  <div
                    key={orderIndex}
                    className={`invoiceOrderItemWrapper order-${order.order_id}`}
                  >
                    <Spin spinning={this.state.isSaving}>
                    <Card
                      size="small"
                      className="marginTop10"
                      title={
                        <Row type={this.props.fromEstimate ? "flex" : undefined} align={this.props.fromEstimate ? "middle" : undefined}>
                          {!this.props.fromEstimate && <Col span={7}>{this.renderTitle(order)}</Col>}
                          {/* <Col span={6} className="fontSize12">
                            {this.renderFMP(order)}
                          </Col> */}
                          {/* <Col span={5} className="fontSize12">
                            {this.renderApplySMP(order)}
                          </Col> */}
                          {orderGroupType !== "TEMPLATE" && 
                            locations.map((loc) => {
                              const losIndex = _.findIndex(invoiceLos[order.order_id], {location_id: loc.location_id})
                              const value = _.get(invoiceLos[order.order_id], `[${losIndex}].level_of_service_code`, '') || ''
                              const levelOfServices = this.state.levelOfServices || [];
                              const type_of_order = !isEmpty(order.related_order) ? 'M' : order.type_of_order;
                              const losForMS = order.type_of_order !== "MS" || _.get(this.props, 'organizationSettings.individual_stop_los_order_level') !== "true";
                              const orderTypeLos = type_of_order && losConfig?.[type_of_order] ? 
                              levelOfServices.filter(rec => losConfig[type_of_order].includes(rec.code)) : 
                              [...levelOfServices]
                              return (losForMS && <Col span={this.props.fromEstimate ? undefined : (locations?.length > 1 ? 7 : 10)} style={this.props.fromEstimate ? { marginRight: "var(--lp-size-6)", whiteSpace: "nowrap" } : undefined}>
                              {loc.order_type}&nbsp;{I18n.t("los.short_form")}&nbsp;:&nbsp;
                                {checkServiceExistance("LOSI") ? (
                                <Select
                                  data-testid={`${loc?.order_type}-los-dropdown`}
                                  size="small"
                                  value={
                                    value
                                  }
                                  showSearch
                                  style={{ width: 180 }}
                                  filterOption={(input, option) =>
                                    option.props.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                  onChange={(e) =>
                                    this.handleLosChange(
                                      order.order_id,
                                      losIndex,
                                      loc.location_id,
                                      e,
                                      loc.level_of_service_code
                                  )}
                                  disabled={this.state.isInvoiceLocked || this.state.isOnHold || isAdjusted}
                                  loading={this.state.losProgress}
                                >
                                  <Select.Option key="LOS" value="">
                                    -- Select --
                                  </Select.Option>
                                  {orderTypeLos.map((los) => (
                                    <Select.Option
                                      key={los.code}
                                      value={los.code}
                                    >
                                      {los.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              ) : (
                                ""
                              )}
                            </Col>)
                            })
                          }
                          {!this.props.fromEstimate && <Col span={3} className="alignRight">
                            {((totalOrders.length > 1 &&
                              invoice.order_group_type == "MOVE") ||
                              invoice.order_group_type == "GROUP") && showActions === true && (
                              <Button
                                data-testid={`remove-button-${order?.order_no}`}
                                loading={isRemovingGroupOrder}
                                size="small"
                                type="danger"
                                disabled={isAdjusted}
                                onClick={() => {
                                  confirmationPopup({
                                    title: I18n.t("messages.action_confirm", {
                                      action: "remove",
                                      field: "Order from Group",
                                    }),
                                    onConfirm: () => {
                                      this.removeGroupedOrder(
                                        order.order_id,
                                        invoice
                                      );
                                    },
                                  });
                                }}
                                icon='close-circle'
                              >
                                Remove
                              </Button>
                            )}
                          </Col>}
                          {this.props.fromEstimate && (
                            <Col className="alignRight" style={{ marginLeft: "auto", whiteSpace: "nowrap" }}>
                              {/* Action buttons moved here from the top bar so they
                                  share the LoS row (estimate only). Same shared
                                  component the Billing header uses. */}
                              <BillingActionButtons
                                showReset={checkServiceExistance("UINLOS")}
                                showRegenerate={checkServiceExistance("UINLOS")}
                                showSendBilling
                                showDownload
                                regenerateLabel={I18n.t("general.recalculate")}
                                regenerateIcon="reload"
                                onReset={this.onReset}
                                onRegenerate={this.recalculateEstimate}
                                onSendBilling={this.showEmailModal}
                                isLocked={isLocked}
                                isSendingMail={this.state.isSendingMail}
                                selectedKeys={selectedInfo?.selectedKeys}
                                retrivePreviewDetails={this.retrivePreviewDetails}
                                downloadParams={this.estimateApiParams()}
                              />
                            </Col>
                          )}
                        </Row>
                      }
                      style={{ textAlign: "left" }}
                    >
                        {this.props.fromEstimate && (
                          <div
                            style={{
                              fontSize: 13,
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              borderBottom: "1px solid var(--lp-color-slate-100)",
                              paddingBottom: "var(--lp-size-2)",
                              marginBottom: 10,
                            }}
                          >
                            {/* Zone info per segment. A shared CSS grid keeps the
                                Zone / Type / Weight / Distance columns aligned across
                                the PICKUP and DELIVERY rows (was zig-zag with gutters). */}
                            <div
                              className="est-zone-row"
                              style={{
                                display: "grid",
                                // Add a Zipcode column only when a segment is a
                                // location / city-zipcode zone (as the old zone card did).
                                gridTemplateColumns: `repeat(${
                                  (invoice.orders_info || []).some((z) =>
                                    ["location", "city-zipcode"].includes(z.zone_type)
                                  )
                                    ? 6
                                    : 5
                                }, max-content)`,
                                columnGap: "var(--lp-size-8)",
                                rowGap: "var(--lp-size-1)",
                                alignItems: "center",
                              }}
                            >
                              {(invoice.orders_info || []).map((zone, idx) => (
                                <React.Fragment key={idx}>
                                  <span className="textBold">
                                    {zone.segment_type
                                      ? zone.is_combo
                                        ? `${I18n.t("service_levels.combo")}:`
                                        : `${zone.segment_type}:`
                                      : ""}
                                  </span>
                                  <span>Zone:&nbsp;<strong>{zone.zone_name || "NA"}</strong></span>
                                  <span>Type:&nbsp;<strong>{zone.zone_type || "NA"}</strong></span>
                                  {(invoice.orders_info || []).some((z) =>
                                    ["location", "city-zipcode"].includes(z.zone_type)
                                  ) && (
                                    <span>
                                      {["location", "city-zipcode"].includes(zone.zone_type) ? (
                                        <React.Fragment>Zipcode:&nbsp;<strong>{zone.zipcode || "NA"}</strong></React.Fragment>
                                      ) : null}
                                    </span>
                                  )}
                                  <span>Weight:&nbsp;<strong>{!isEmpty(zone.weight) ? `${zone.weight} ${zone.weight_units || AppConfig.weight_unit}` : "NA"}</strong></span>
                                  <span>Distance:&nbsp;<strong>{!isEmpty(zone.distance) ? `${parseFloat(zone.distance)} ${AppConfig.distance_unit}` : "NA"}</strong></span>
                                </React.Fragment>
                              ))}
                            </div>
                            <div className="textBold primaryText" style={{ fontSize: "var(--lp-font-size-lg)", whiteSpace: "nowrap", paddingLeft: "var(--lp-size-6)", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "var(--lp-size-2)" }}>
                              {/* Consolidation icon + redirect (billing shows it in
                                  renderTitle, which the estimate hides). */}
                              {order.is_consolidated === "true" && (
                                <ConsolidationButton
                                  displayType="icon"
                                  openInModal
                                  consolidation_no={order.consolidation_number}
                                  consolidate_order_id={order.consolidated_id}
                                  orders={[order]}
                                  label={I18n.t("consolidation.consolidation_details")}
                                  handleSuccess={() => this.getBillingDetails(order.order_id)}
                                  styleObj={{ width: 18, display: "block" }}
                                />
                              )}
                              <span>
                                {I18n.t("invoices.total")}:{" "}
                                {this.state.isLoading ? (
                                  <Icon type="loading" style={{ fontSize: 14 }} spin />
                                ) : (
                                  checkNegitive(invoice.total_amount)
                                )}
                              </span>
                              {/* Group orders + their machine pricing (FMP/SMP),
                                  shown to the right of the amount. Only when the
                                  backend returns a group. */}
                              {invoice.group_orders && invoice.group_orders.length > 0 && (
                                <OrderPriceTypePopover charges={invoice.group_orders} />
                              )}
                            </div>
                          </div>
                        )}
                        {!this.props.fromEstimate && (<Row className="marginBottom10" justify="space-between" type="flex">
                        <Col span={(!isEmpty(order.mawb) || !isEmpty(order.hawb) || !isEmpty(order.driver_notes)) ? order.type_of_order === "MS" ? 4 : 6 : 0}>
                          <>
                              <h4
                                style={{ marginBottom: 0 }}
                                className="textBold"
                              >
                                {" "}
                                {I18n.t("order.details")}{" "}
                              </h4>
                              <Row>
                              <Col span={24}>
                                  <Typography.Text strong>
                                    Weight:
                                  </Typography.Text>
                                  <Typography.Text>
                                    {formatWeightBothUnitsAsIs(
                                      order?.lbs_weight,
                                      order?.kgs_weight
                                    )}
                                  </Typography.Text>
                                </Col>
                                <Col span={24}>
                                  <Typography.Text strong>Actual Weight: </Typography.Text>
                                  <Typography.Text>
                                    {formatWeightBothUnitsAsIs(
                                      order?.actual_weight,
                                      order?.actual_weight_in_kgs
                                    )}
                                  </Typography.Text>
                                </Col>
                                {!isEmpty(this.props.organizationSettings.cbm_volume) && <Col span={24}>
                                  <Typography.Text strong>CBM Volume: </Typography.Text>
                                  <Typography.Text>
                                  {order?.cbm_volume || "N/A"}
                                  </Typography.Text>
                                </Col>
                              }
                                <Col span={24}>
                                  <Typography.Text strong>
                                    Quantity:{" "}
                                  </Typography.Text>
                                  {order.quantity ? (
                                    <OrderQuantity
                                      record={order}
                                      key={`unm${order.order_id}`}
                                      keyId={`un${order.order_id}`}
                                      primaryKey="order_id"
                                      showActions={true}
                                      style={{
                                        textDecoration: "underline",
                                        textDecorationColor: "red",
                                        textDecorationThickness: "3px",
                                      }}
                                    >
                                      {order.quantity}
                                    </OrderQuantity>
                                  ) : (
                                    "N/A"
                                  )}
                                </Col>
                                <Col span={24}>
                                  <Typography.Text strong>
                                    Surface Area:
                                  </Typography.Text>
                                  <Typography.Text>
                                    {order.surface_area ? (
                                      <Fragment>
                                        {order.surface_area} (
                                        {I18n.t("order.surface_area_units")}{" "}
                                        <sup>2</sup>)
                                      </Fragment>
                                    ) : (
                                      "N/A"
                                    )}
                                  </Typography.Text>
                                </Col>
                                <Col span={24}>
                                  <Typography.Text strong>
                                    Skids / Pallets:
                                  </Typography.Text>
                                  <Typography.Text>
                                    {order.pallets || "N/A"}
                                  </Typography.Text>
                                </Col>
                              </Row>
                            </>
                          </Col>
                          <Col className="paddingLeft15 border-left-light" span={(!isEmpty(order.mawb) || !isEmpty(order.hawb) || !isEmpty(order.driver_notes)) ? order.type_of_order === "MS" ? 4 : 6 : 0}>
                            {(!isEmpty(order.mawb) ||
                              !isEmpty(order.hawb) ||
                              !isEmpty(order.driver_notes)) && (
                                <Fragment>
                                  <h4
                                    style={{ marginBottom: 0 }}
                                    className="textBold"
                                  >
                                    {" "}
                                    {I18n.t("order.reference_label")}{" "}
                                  </h4>
                                  {!isEmpty(order.mawb) && (
                                    <Row>
                                      <Col xs={24}>
                                      <Row type="flex">
                                        <Col>
                                        <span>
                                          {I18n.t("general.mawb")}
                                          &nbsp;&nbsp;:&nbsp;&nbsp;
                                        </span>
                                        </Col>
                                        <Col>
                                          <Row className="textBold" type="flex" gutter={10}>
                                            <Col>
                                              {this.state.isEditMawbDate ? (
                                                <Input
                                                  data-testid={`mawb-input-${order.order_number}`}
                                                  size="small"
                                                  style={{ width: '110px' }}
                                                  value={this.state.editableMawb}
                                                  onChange={(e) => {
                                                    const inputValue = e.target.value.toUpperCase();
                                                    this.setState({ editableMawb: inputValue });
                                                  }}
                                                  autoFocus
                                                  onPressEnter={this.saveMawbDateChange}
                                                />
                                              ) : (
                                                ellipseText(doFormate(order.mawb), 15, true)
                                              )}
                                            </Col>
                                            <Col>
                                              {this.state.isEditMawbDate ? (
                                                <Row type="flex" gutter={5}>
                                                  <Col>
                                                    <Icon
                                                      data-testid={`save-button-${order.order_number}`}
                                                      type="save"
                                                      theme="twoTone"
                                                      className="fontSize14 cusorPointer"
                                                      onClick={() => this.saveMawbDateChange()}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Icon
                                                      data-testid={`close-button-${order.order_number}`}
                                                      type="close"
                                                      className="fontSize14 cusorPointer"
                                                      onClick={() => this.closeMawbDatePicker()}
                                                    />
                                                  </Col>
                                                </Row>
                                              ) : (
                                                BillingMethod === "warehouse_template_billing" ? (
                                                  <EditIcon handleClick={() => this.handleEditMawbDate(true)} />
                                                ) : (
                                                  ""
                                                )
                                              )}
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      </Col>
                                    </Row>
                                  )}
                                  {!isEmpty(order.hawb) && (
                                    <Row>
                                      <Col xs={24}>
                                      <Row type="flex">
                                        <Col>
                                          { I18n.t("general.hawb") }
                                          &nbsp;&nbsp;:&nbsp;&nbsp;
                                        </Col>
                                        <Col>
                                          <Row className="textBold" type="flex" gutter={ 10 }>
                                            <Col>
                                              { this.state.isEditHawbDate ? (
                                                <Input
                                                  data-testid={`hawb-input-${order.order_number}`}
                                                  size="small"
                                                  style={ { width: '110px' } }
                                                  value={ this.state.editableHawb }
                                                  onChange={ (e) => {
                                                    const inputValue = e.target.value.toUpperCase();
                                                    const trimmedValue = this.trimDateFromHawb(inputValue);
                                                    console.log(trimmedValue);
                                                    this.setState({ editableHawb: trimmedValue });
                                                  } }
                                                  onPressEnter={ this.saveHawbDateChange }
                                                />
                                              ) : (
                                                ellipseText(doFormate(order.hawb), 15, true)
                                              ) }
                                            </Col>
                                            <Col>
                                              { this.state.isEditHawbDate ? (
                                                <Row type="flex" gutter={ 5 }>
                                                  {orderGroupType == "TEMPLATE" && <Col>
                                                    <DatePicker
                                                      size="small"
                                                      format={ "MMM D" }
                                                      className="date-picker-selection-only"
                                                      onChange={ this.onHawbDateChange }
                                                      style={ { width: '120px' } }
                                                      allowClear={ false }
                                                      autoFocus
                                                    />
                                                  </Col>}
                                                  <Col>
                                                    <Icon
                                                      type="save"
                                                      theme="twoTone"
                                                      className="fontSize14 cusorPointer"
                                                      onClick={ () => this.saveHawbDateChange() }
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Icon
                                                      type="close"
                                                      className="fontSize14 cusorPointer"
                                                      onClick={ () => this.closeHawbDatePicker() }
                                                    />
                                                  </Col>
                                                </Row>
                                              ) : (
                                                  orderGroupType === "TEMPLATE" || BillingMethod === "warehouse_template_billing" ? <EditIcon handleClick={ () => this.handleEditHawbDate(true) } /> : ""
                                              ) }
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                      </Col>
                                    </Row>
                                  )}
                                </Fragment>
                              )}
                          </Col>
                          { _.get(this.props, 'organizationSettings.individual_stop_los_order_level', '') == "true" && order.type_of_order === "MS" &&
                            <Col className="paddingLeft15 border-left-light" style={{ overflowY: "auto", height: "135px" }} span={7}>
                              {level_of_service_MS()}
                            </Col>
                          }
                          {driverObjects && orderGroupType === "TEMPLATE" &&(
                            <Col
                            span={ orderGroupType === "TEMPLATE" && (!isEmpty(order.mawb) ||  !isEmpty(order.hawb) || !isEmpty(order.driver_notes))? 6 : 4}
                              className="paddingLeft15 border-left-light"
                            >
                                {/* <Card size="small" bodyStyle={{ height: 185, fontSize: 12 }}> */}
                                  <h3 className="main_heading primaryText fontSize16">
                                    {I18n.t("account.details")}
                                  </h3>
                                  <span className="textBold">
                                    <Fragment>{invoice.account_details.name}</Fragment>
                                  </span>
                                  <div>
                                    <Col xs={1}>
                                      <Icon type="environment" />
                                    </Col>
                                    <Col xs={23}>
                                      <InvoiceContact
                                        data={invoice.account_details}
                                        // showIcon
                                        showAddr
                                        displayType="mixFormat"
                                      />
                                    </Col>
                                  </div>
                                {/* </Card> */}
                            </Col>
                          )}
                          {driverObjects && (
                            <Col
                              span={ orderGroupType === "TEMPLATE" && ( !isEmpty(order.mawb) ||  !isEmpty(order.hawb) || !isEmpty(order.driver_notes)) ? 6 : 8}
                              className="paddingLeft15 border-left-light"
                            >
                              <BillingDrivers
                                invoice={invoice}
                                currentObj={driverObjects ? driverObjects : {}}
                                isReadyOnly={isReadyOnly}
                                showActions={showActions}
                                driversList = {this.state.driversList}
                                updateDriverDetails={this.updateDriverDetails}
                                hasOrderGroupTypeTemplate={orderGroupType === "TEMPLATE"}
                                // getInvoices={this.props.getInvoices}
                              />
                            </Col>
                          )}
                        </Row>)}
                        {Object.values(order.instructions).some(
                          (value) =>
                            value != null &&
                            value !== "" &&
                            value !== undefined
                        ) && (
                            <Row
                            className="border-top-light border-bottom-light paddingBottom15 paddingTop15"
                              xs={12}
                            >
                              <InstructionsDisplay
                                instructions={_.get(order, "instructions")}
                                driverNotes={_.get(order, "driver_notes")}
                              />
                            </Row>
                          )}

                      <Row>
                        {order.is_prepaid === true && (
                          <Col span={24}>
                            <PrepaidAmountWithPreview
                              variant="compact"
                              amount={order.prepaid_amount}
                              cashReceiptLegs={cashReceiptLegsForOrder(
                                invoice.cash_receipt_pictures,
                                order.order_id
                              )}
                            />
                          </Col>
                        )}
                        {invoice.transportation_charges.length > 0 && (
                          <Col sm={24} xs={24} md={24} lg={24}>
                            {invoice.transportation_charges
                              .filter((section) => section.order_id === order.order_id)
                              .map((section) => (
                                <ChargesSection
                                  key={`transport-${section.order_number}`}
                                  title={I18n.t("invoices.charges")}
                                  chargeType="transportation_charges"
                                  fromEstimate={this.props.fromEstimate}
                                  section={section}
                                  locations={locations}
                                  allLocations={allLocations}
                                  isTemplateZoneBilling={this.state.currentOrderGroupType === "TEMPLATE"}
                                  isInvoiceLocked={this.state.isInvoiceLocked}
                                  isReadyOnly={isReadyOnly}
                                  showActions={showActions}
                                  isOnHold={this.state.isOnHold}
                                  isAdjusted={isAdjusted}
                                  handleAddItem={this.addItem}
                                  handleIndvAddItem={this.addIndvItem}
                                  handleItemsChange={(index, element, value, orderNo) =>
                                    this.handleItemsChange(index, element, value, "transportation_charges", orderNo)
                                  }
                                  handleIndvItemsChange={(index, element, value, orderNo) =>
                                    this.handleIndvOnItemsChange(index, element, value, "transportation_charges", orderNo)
                                  }
                                  handleDeleteClick={this.handleDeleteclick}
                                  handleIndvDeleteclick={this.handleIndvDeleteclick}
                                  handleInputSaveItem={this.handleInputSaveItem}
                                  handleIndvInputSaveItem={this.handleIndvInputSaveItem}
                                  findSectionTotal={this.findSectionTotal}
                                  findIndvSectionTotal={this.findIndvSectionTotal}
                                  orderData={order}
                                  orderDataWithLocations={orderDataWithLocations}
                                  glCodesList={this.props.glCodesList}
                                  handleEditItem={this.editItem}
                                  handleEditIndvItem={this.editIndvItem}
                                  cancelEditItem={this.cancelEditItem}
                                  indvCancelEditItem={this.indvCancelEditItem}
                                  editSave={this.editSave}
                                  editIndvSave={this.editIndvSave}
                                  removeEditingVals={this.state.removeEditingVals}
                                  removeIndvEditingVals={this.state.removeIndvEditingVals}
                                  ikeaChargesrecord={this.state.ikeaChargesrecord}
                                  updateRecords={this.handleUpdateRecords}
                                  defaultTransportationChargeGLCode={this.state.defaultTransportationChargeGLCode}
                                  isInvoiceApproved={isInvoiceApproved}
                                  screenType={"ManageBilling"}
                                  // expand line items
                                 expandedRowId={this.state.expandedRowIds["transportation_charges"] || ''}
                                 expandedChargeLineData={this.state.expandedChargeLineData["transportation_charges"] || []}
                                 onRowExpand={(expanded, record) =>
                                   this.handleLineExpand(expanded, record, section, "transportation_charges")
                                 }
                                  // no modify checkbox change
                                  handleNoModifyChange={this.handleNoModifyChange}
                                  //
                                  addNewChargeLine={addNewChargeLine}
                                />
                              ))}
                          </Col>
                        )}
                        {invoice.fuel_surcharges.length > 0 && orderGroupType !== "TEMPLATE" && (
                          <Col sm={24} xs={24} md={24} lg={24} className="marginTop10">
                            {invoice.fuel_surcharges
                              .filter((section) => section.order_id === order.order_id)
                              .map((section) => (
                                <ChargesSection
                                  key={`fuel-${section.order_number}`}
                                  title={I18n.t("invoice_lines.fuel_surcharges")}
                                  chargeType="fuel_surcharges"
                                  fromEstimate={this.props.fromEstimate}
                                  section={section}
                                  locations={locations}
                                  allLocations={allLocations}
                                  isTemplateZoneBilling={false}
                                  isInvoiceLocked={this.state.isInvoiceLocked}
                                  isReadyOnly={isReadyOnly}
                                  showActions={showActions}
                                  isOnHold={this.state.isOnHold}
                                  isAdjusted={isAdjusted}
                                  handleAddItem={this.addItem}
                                  handleIndvAddItem={this.addIndvItem}
                                  handleItemsChange={(index, element, value, orderNo) =>
                                    this.handleItemsChange(index, element, value, "fuel_surcharges", orderNo)
                                  }
                                    handleIndvItemsChange={(index, element, value, orderNo) =>
                                    this.handleIndvOnItemsChange(index, element, value, "fuel_surcharges", orderNo)
                                  }
                                  handleDeleteClick={this.handleDeleteclick}
                                  handleIndvDeleteclick={this.handleIndvDeleteclick}
                                  handleInputSaveItem={this.handleInputSaveItem}
                                  handleIndvInputSaveItem={this.handleIndvInputSaveItem}
                                  findSectionTotal={this.findSectionTotal}
                                  findIndvSectionTotal={this.findIndvSectionTotal}
                                  orderData={order}
                                  orderDataWithLocations={orderDataWithLocations}
                                  glCodesList={this.props.glCodesList}
                                  handleEditItem={this.editItem}
                                  handleEditIndvItem={this.editIndvItem}
                                  cancelEditItem={this.cancelEditItem}
                                  indvCancelEditItem={this.indvCancelEditItem}
                                  editSave={this.editSave}
                                  editIndvSave={this.editIndvSave}
                                  removeEditingVals={this.state.removeEditingVals}
                                  removeIndvEditingVals={this.state.removeIndvEditingVals}
                                  fuelPercentEdit={this.fuelPercentEdit}
                                  currentProcessedId={this.state.currentProcessedId}
                                  fuelPercentSave={this.fuelPercentSave}
                                  onFuelPercentChange={this.onFuelPercentChange}
                                  editedFuelPercent={this.state.editedFuelPercent}
                                  fuelPercentCancel={this.fuelPercentCancel}
                                  handleKeyDown={this.handleKeyDown}
                                  screenType={"ManageBilling"}
                                  // expand line items
                                   expandedRowId={this.state.expandedRowIds["fuel_surcharges"] || ''}
                                   expandedChargeLineData={this.state.expandedChargeLineData["fuel_surcharges"] || []}
                                   onRowExpand={(expanded, record) =>
                                     this.handleLineExpand(expanded, record, section, "fuel_surcharges")
                                   }
                                  // no modify checkbox change
                                  handleNoModifyChange={this.handleNoModifyChange}
                                  //
                                  addNewChargeLine={addNewChargeLine}
                                />
                              ))}
                          </Col>
                        )}
                        {checkServiceExistance("AAAAC") && invoice.accessorial_charges.length > 0 && orderGroupType !== "TEMPLATE" && (
                          <Col sm={24} xs={24} md={24} lg={24} className="marginTop10">
                            {invoice.accessorial_charges
                              .filter((section) => section.order_id === order.order_id)
                              .map((section) => (
                                <ChargesSection
                                  key={`accessorial-${section.order_number}`}
                                  title={I18n.t("invoices.accessorial_charges")}
                                  chargeType="accessorial_charges"
                                  fromEstimate={this.props.fromEstimate}
                                  estimateApiParams={this.estimateApiParams()}
                                  section={section}
                                  locations={locations}
                                  isTemplateZoneBilling={false}
                                  isInvoiceLocked={this.state.isInvoiceLocked}
                                  isReadyOnly={isReadyOnly}
                                  showActions={showActions}
                                  isOnHold={this.state.isOnHold}
                                  isAdjusted={isAdjusted}
                                  handleAddItem={this.addItem}
                                  handleIndvAddItem={this.addIndvItem}
                                  handleItemsChange={(index, element, value, orderNo) =>
                                    this.handleItemsChange(index, element, value, "accessorial_charges", orderNo)
                                  }
                                   handleIndvItemsChange={(index, element, value, orderNo) =>
                                    this.handleIndvOnItemsChange(index, element, value, "accessorial_charges", orderNo)
                                  }
                                  handleDeleteClick={this.handleDeleteclick}
                                  handleIndvDeleteclick={this.handleIndvDeleteclick}
                                  handleInputSaveItem={this.handleInputSaveItem}
                                  handleIndvInputSaveItem={this.handleIndvInputSaveItem}
                                  findSectionTotal={this.findSectionTotal}
                                  findIndvSectionTotal={this.findIndvSectionTotal}
                                  orderData={order}
                                  orderDataWithLocations={orderDataWithLocations}
                                  glCodesList={this.props.glCodesList}
                                  handleEditItem={this.editItem}
                                  handleEditIndvItem={this.editIndvItem}
                                  cancelEditItem={this.cancelEditItem}
                                  indvCancelEditItem={this.indvCancelEditItem}
                                  editSave={this.editSave}
                                  editIndvSave={this.editIndvSave}
                                  removeEditingVals={this.state.removeEditingVals}
                                  removeIndvEditingVals={this.state.removeIndvEditingVals}
                                  accessorials={this.state.accessorials}
                                  invoice={invoice}
                                  technicians={this.state.technicians}
                                  drivers={this.state.drivers}
                                  orgId={userStore.getStateValue("selectedOrg")}
                                  accountId={invoice.account_details?.id}
                                  orderId={order.order_id}
                                  reqData={this.state.accessorials}
                                  orgrules={_.get(this.props, 'userContext.orgRules.org_billing_rules', {})}
                                  handleRecordUpdate={(record, index, currentOrderNo) => this.handleRecordUpdate(index, "accessorial_charges", currentOrderNo, record)}
                                  refreshParentDetails={() => { this.props.handleIsLosChanged(true); this.getBillingDetails(this.state.invoice.customer_order_id); }}
                                  refreshAccessorial={this.getAccessorials}
                                  orgComponents={this.state.orgComponents}
                                  displayComponents={this.state.displayComponents}
                                  accountComponentAccessorial={this.state.accountComponentAccessorial}
                                  orderAccessorials={this.state.orderAccessorials}
                                  authorizeDetails={this.state.authorizeDetails}
                                  slotConfig={this.state.slotConfig}
                                  reapproveBilling={this.handleReapprove}
                                  isMilitaryTime={this.state.organizationSettings.is_military_time}
                                  screenType={"ManageBilling"}
                                  handleOnItemsChange={(recordNO, element, value, orderNo) => this.handleOnItemsChange(recordNO, element, value, "accessorial_charges", orderNo)}
                                  addNewChargeLine={addNewChargeLine}
                                />
                              ))}
                          </Col>
                        )}
                        {invoice.adjustment_charges.length > 0 && orderGroupType !== "TEMPLATE" && (
                          <Col sm={24} xs={24} md={24} lg={24} className="marginTop10">
                            {invoice.adjustment_charges
                              .filter((section) => section.order_id === order.order_id)
                              .map((section) => (
                                <ChargesSection
                                  key={`adjustment-${section.order_number}`}
                                  title={I18n.t("invoices.adjustments")}
                                  chargeType="adjustment_charges"
                                  fromEstimate={this.props.fromEstimate}
                                  section={section}
                                  locations={locations}
                                  allLocations={allLocations}
                                  isTemplateZoneBilling={false}
                                  isInvoiceLocked={this.state.isInvoiceLocked}
                                  isReadyOnly={isReadyOnly}
                                  showActions={showActions}
                                  isOnHold={this.state.isOnHold}
                                  isAdjusted={isAdjusted}
                                  handleAddItem={this.addItem}
                                  handleIndvAddItem={this.addIndvItem}
                                  handleItemsChange={(index, element, value, orderNo) =>
                                    this.handleItemsChange(index, element, value, "adjustment_charges", orderNo)
                                  }
                                   handleIndvItemsChange={(index, element, value, orderNo) =>
                                    this.handleIndvOnItemsChange(index, element, value, "adjustment_charges", orderNo)
                                  }
                                  handleDeleteClick={this.handleDeleteclick}
                                  handleIndvDeleteclick={this.handleIndvDeleteclick}
                                  handleInputSaveItem={this.handleInputSaveItem}
                                  handleIndvInputSaveItem={this.handleIndvInputSaveItem}
                                  findSectionTotal={this.findSectionTotal}
                                  findIndvSectionTotal={this.findIndvSectionTotal}
                                  orderData={order}
                                  orderDataWithLocations={orderDataWithLocations}
                                  glCodesList={this.props.glCodesList}
                                  handleEditItem={this.editItem}
                                  handleEditIndvItem={this.editIndvItem}
                                  cancelEditItem={this.cancelEditItem}
                                  indvCancelEditItem={this.indvCancelEditItem}
                                  editSave={this.editSave}
                                  editIndvSave={this.editIndvSave}
                                  removeEditingVals={this.state.removeEditingVals}
                                  removeIndvEditingVals={this.state.removeIndvEditingVals}
                                  screenType={"ManageBilling"}
                                  // expand line items
                                  expandedRowId={this.state.expandedRowIds['adjustment_charges'] || ''}
                                  expandedChargeLineData={this.state.expandedChargeLineData['adjustment_charges'] || []}
                                  onRowExpand={(expanded, record) =>
                                    this.handleLineExpand(expanded, record, section, 'adjustment_charges')
                                  }
                                  //
                                  addNewChargeLine={addNewChargeLine}
                                />
                              ))}
                          </Col>
                        )}
                      </Row>
                    </Card>
                    </Spin>

                    <Row className="marginTop15">
                      <Col
                        data-testid="invoice-job-total"
                        xs={24}
                        className="textBold alignRight textPrimary fontSize18"
                        style={{ paddingRight: 85 }}
                      >
                        Job Total: {checkNegitive(jobTotal)}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={24}>
                        <Divider />
                      </Col>
                    </Row>
                  </div>
                );
              })}
            </div>
              <Col sm={ 24 } xs={ 24 } md={ 24 } lg={ 24 } className="marginTop10">
                <Row>
                <Col className="alignRight">
                  <h4
                    data-testid="invoice-total-amount"
                    className="textBold fontSize20"
                    style={{ paddingRight: 85, marginTop: 20 }}
                  >
                    {I18n.t("invoices.total")}:{" "}
                    {this.state.currentOrderGroupType === "TEMPLATE" ? checkNegitive(ikeaTotal) : checkNegitive(invoice.total_amount)}
                  </h4>
                </Col>
              </Row>
            </Col>
            <Col xs={24}>{FormErrors(this.state.errors)}</Col>
              { errors.length > 0 && (
              <Col xs={24} className="marginTop10">
                <FormItem label={I18n.t("general.exceptions")}>
                  <div className="borderLine padding5">
                      { _.isString(errors[ 0 ])
                        ? FormattedErrors(errors, I18n.t("general.exceptions"))
                      : <Fragment />}
                  </div>
                </FormItem>
                {false && (
                  <Alert message={invoice.error_messages} type="error" />
                )}
              </Col>
            )}

            {invoice.remarks.length > 0 && (
              <Col sm={24} xs={24} md={24} lg={24} className="billing-remarks-section">
                <FormItem
                  label={I18n.t("general.notes")}
                  className="billing-remarks-form-item"
                  style={{ marginBottom: 4, label: { fontWeight: 700 } }}
                >
                  <Remarks
                    data={invoice.remarks || []}
                    timeZoneId={invoice?.warehouse_details?.time_zone || invoice?.time_zone_id}
                  />
                </FormItem>
              </Col>
            )}
            {invoice.status === "EXCEPTION" && (
              <Row>
                <Col xs={24} className="paddingLeft5">
                  <Fragment>
                    <span className="fontSize12">Exception:</span>&nbsp;
                    <span className="textRed notes_content fontsize11">
                      {invoice.exception_message}
                    </span>
                  </Fragment>
                </Col>
              </Row>
            )}
            {showAddNotes && (
              <Fragment>
                {!this.state.showRemarks && showAddNotes === true ? (
                  <Col xs={24} className="alignRight billing-add-notes-action">
                    <Button
                      data-testid="invoice-add-notes-button"
                      type="link"
                      size="small"
                      onClick={() => this.showRemarksModal()}
                    >
                      <Icon type="plus-circle" />
                      &nbsp;{I18n.t("invoices.add_remark")}
                    </Button>
                  </Col>
                ) : (
                  <Fragment>
                    {showAddNotes === true && (
                    <Col xs={24} className="marginTop10">
                      <FormItem
                        label={`${I18n.t("general.add")} ${I18n.t(
                          "general.notes"
                        )}`}
                      >
                        <TextArea
                          data-testid="invoice-notes-input"
                          rows={4}
                          placeholder={I18n.t("general.notes")}
                          className="sop-form-textArea"
                          value={this.state.comments}
                          onChange={(e) =>
                            this.handleRemarksChange("comments", e.target.value)
                          }
                        />
                        {checkServiceExistance("BLUIND") && showAddNotes === true && (
                          <div style={{ textAlign: "center" }}>
                            <Button data-testid="notes-cancel-button" onClick={this.closeRemarksModal} icon='close'>
                              {I18n.t("general.cancel")}
                            </Button>
                            <Button
                              data-testid="notes-save-button"
                              onClick={this.handleSave}
                              disabled={this.state.disableRemarksButton}
                              className="assignDriver"
                              style={{ margin: 10 }}
                              loading={this.state.loading}
                              icon='save'
                            >
                              {I18n.t("general.save")}
                            </Button>
                          </div>
                        )}
                      </FormItem>
                    </Col>
                    )}
                  </Fragment>
                )}
              </Fragment>
            )}
          </Row>
          {!this.state.showRemarks && !isLocked && !this.props.fromEstimate && (
              <Row>
              <Col xs={24} className="alignCenter marginTop15 billingActions">
                  {!this.props.hideCloseButton && (
                  <Button data-testid="invoice-close-button" type="primary" onClick={this.props.closeModal} icon='close'>
                    Close
                  </Button>
                  )}
                          {!isFromPendingBucket && this.state.isOnHold &&
                            <>
                              &nbsp;&nbsp;
                              <Popconfirm
                                placement="topRight"
                                title={I18n.t("messages.confirm")}
                                onConfirm={()=>this.handleSaveReadyForBilling("READY_FOR_BILLING")}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button data-testid="ready-for-bill-button" type="primary" icon="file-done">Ready For Billing</Button>
                              </Popconfirm>
                            </>
                          }
                          &nbsp;&nbsp;
                          {
                            !isFromPendingBucket &&
                            this.props.organizationSettings.show_hold_bucket == "true" &&
                             checkServiceExistance("FBLOS") &&
                            this.state.invoice.status == "READY_FOR_BILLING" &&
                            // window.location.href.split("/").pop() == "billing" &&
                            !this.state.isOnHold && (
                              <>
                                  <Button data-testid="invoice-hold-button" className="buttonYellow" icon="pause-circle" onClick={() => this.setState({openConfirmModal: true, confirmModalType: "hold"})}>
                                    Hold
                                  </Button>
                                &nbsp;&nbsp;
                              </>
                            )
                          }
                          {
                            !isFromPendingBucket &&
                            this.props.organizationSettings.show_pending_bucket == "true" &&
                            ["READY_FOR_BILLING", "APPROVED"].includes(this.state.invoice.status) &&
                            !this.state.isOnHold &&
                            !isLocked && (
                              <>
                                  <Button className="buttonRed" icon="clock-circle" onClick={() => this.setState({openConfirmModal: true, confirmModalType: "pending"})}>
                                    Reject
                                  </Button>
                                &nbsp;&nbsp;
                              </>
                            )
                          }
                {checkServiceExistance(["BLSIND", "SPB"], "ANY") &&
                showSavePrintActions === true && (
                  <Button data-testid="invoice-save-button" type="primary" onClick={isTemplateZoneBilling ? this.saveTemplateZoneBilling : this.saveInvoiceForm}  icon='save'>
                    Save
                  </Button>
                )}
                { !isFromPendingBucket && isInvoiceApproved && !isLocked && (
                  <Button data-testid="invoice-save-re-approve-button" type="primary" onClick={isTemplateZoneBilling ? this.saveTemplateZoneBilling : () => this.handleSaveAndReapprove(selectedInfo, true)}  icon='save' loading={this.state.isRepproveLoading}>
                    Save & Re-Approve
                  </Button>
                )}
                &nbsp;&nbsp;
                { !isFromPendingBucket && showActions === true && !hasConsolidatedOrders && checkServiceExistance("BLUS") && !isLocked &&
                  !isReadyOnly &&
                  invoice.status === "APPROVED" && (
                    <Fragment>
                      <ApproveInvoices
                        selectedInfo={{ ...selectedInfo }}
                        action={
                          invoice.status === "READY_FOR_BILLING"
                            ? "APPROVED"
                            : "REAPPROVED"
                        }
                        buttonType="primary"
                        className="buttonCerulean"
                        isDisabled={!(selectedInfo.selectedKeys.length > 0)}
                        showActions = {showActions}
                        label={
                          invoice.status === "READY_FOR_BILLING"
                            ? I18n.t("invoices.approve")
                            : I18n.t("invoices.reapprove")
                        }
                        handleSuccess={() =>
                          this.handleApproveSuccess("APPROVED")
                        }
                        handleCancel={()=>{}}
                        screenFrom="form"
                        is_pickup_by_driver={this.state.is_pickup_by_driver}
                        pickup_order_driver_id={
                          this.state.pickup_order_driver_id
                        }
                        pickup_order_amount={this.state.pickup_order_amount}
                      />
                    </Fragment>
                  )}
                &nbsp;&nbsp;
                {!isFromPendingBucket && showActions === true && !hasConsolidatedOrders && checkServiceExistance("BLUS") && !isLocked && 
                  !isReadyOnly &&
                  !["EXCEPTION", "APPROVED"].includes(invoice.status) && (
                    <Fragment>
                      <ApproveInvoices
                        selectedInfo={{ ...selectedInfo }}
                        action={
                          invoice.status === "READY_FOR_BILLING"
                            ? "APPROVED"
                            : "REAPPROVED"
                        }
                        buttonType="primary"
                        className="buttonCerulean"
                        isDisabled={!(selectedInfo.selectedKeys.length > 0)}
                        label={
                          invoice.status ===
                          I18n.t("invoices.ready_for_billing")
                            ? I18n.t("invoices.approved_to_go_to_invoice")
                            : invoice.status === "APPROVED"
                            ? I18n.t("invoices.payment_confirmed")
                            : I18n.t("invoices.close")
                        }
                        handleSuccess={() =>
                          this.handleApproveSuccess("APPROVED")
                        }
                        handleCancel={()=>{}}
                        screenFrom="form"
                        is_pickup_by_driver={this.state.is_pickup_by_driver}
                        pickup_order_driver_id={
                          this.state.pickup_order_driver_id
                        }
                        pickup_order_amount={this.state.pickup_order_amount}
                        userContext={this.props.userContext}
                        handleValidation={this.handleValidation}
                      />
                    </Fragment>
                  )}
                  {showPendingManageActions && (
                    <Button
                      data-testid="pending-approve-button"
                      type="primary"
                      className="buttonCerulean marginLeft10"
                      icon="check-circle"
                      loading={this.state.approveInProgress}
                      onClick={this.openApprovalReasonModal}
                    >
                      Ready for billing
                    </Button>
                  )}
                  {showSavePrintActions === true && (
                    <BillingPdfDownload
                      className={"buttonCoolBlue marginLeft10"}
                      buttonType="primary"
                      size="default"
                      label={"Download / " + I18n.t("general.print")}
                      isDisabled={selectedInfo.selectedKeys.length === 0}
                      handleSuccess={() => {}}
                      orderIds={[...selectedInfo.selectedKeys]}
                      retrivePreviewDetails={this.retrivePreviewDetails}
                      screenFrom="form"
                    />
                  )}
              </Col>
            </Row>
          )}
           { this.props.showPictures && !this.props.fromEstimate && <Row className="marginTop20" style={ {
              paddingBottom: 20,
            } }>
            <this.renderOrderPics />
          </Row>}
          {!this.props.fromEstimate && (<Row>
          <Col>
             <Checkbox
               className="ar-paperwork-check"
               data-testid="paper-work-check"
               checked={this.state.isPaperWorkDone || false}
               disabled={this.state.isLoading}
               onChange={(e) => {
                 const checked = e.target.checked;
                 if (this.state.isLoading) return;
                 // No optimistic toggle: the checkbox is driven by server state
                 // only. paperWorkChecked flips it after a successful save, so a
                 // validation error leaves the box unchanged instead of flicking
                 // checked then unchecked.
                 this.paperWorkChecked(checked);
               }}
             >
               <strong>I ensure that all the paper work has been verified</strong>
             </Checkbox>
          </Col>

          </Row>)}
                  </div>
                </TabPane>
                {!this.props.fromEstimate && !isFromPendingBucket && !this.state.isOnHold && orderGroupType !=="TEMPLATE" && <TabPane tab="Driver Pays" key="driver_pay">
                  <BillingDriverPay
                    drivers={ this.state.drivers }
                    currentInvoice={ this.state.invoice }
                    isLocked={ isLocked }
                    glCodesList={this.props.glCodesList}
                    updateParentComponent={this.handleUpdateInvoice}
                    userContext={this.props.userContext}
                  />
                </TabPane>}
                {isFromPendingBucket && (
                  <TabPane tab="Remarks" key="remarks">
                    <BillingRemarksTabContent
                      invoice={invoice}
                      timeZoneId={invoice?.warehouse_details?.time_zone || invoice?.time_zone_id}
                    />
                  </TabPane>
                )}
                {!this.props.fromEstimate && <TabPane tab={I18n.t("order.activities")} key="activities">
                  {!_.isEmpty(this.state.billingActivitiesList) ?
                    <Row type="flex" gutter={[16, 16]} data-testid="activities-tab">
                      <Col span={12}>
                        <Search
                          data-testid="orders-search-input"
                          onChange={this.searchBar}
                          placeholder={I18n.t("general.search")}
                          // onSearch={value => this.searchBar(value)}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col span={12}>
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <label
                            style={{ marginRight: "10px", marginTop: "2px" }}
                          >
                            Order(s):
                          </label>
                          <Select
                            data-testid="orders-number-search-input"
                            className={
                              this.state.filteredOrdersForActivities.length ===
                              1
                                ? "one-tag"
                                : ""
                            }
                            value={this.state.filteredOrdersForActivities}
                            onChange={(value) => this.filterOrderNos(value)}
                            mode="multiple"
                            maxTagCount={3}
                            style={{ width: "80%" }} // Reduced width
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.state.filterOrderIds.map((order) => (
                              <Select.Option
                                key={order.order_number}
                                value={order.order_number}
                              >
                                {order.order_number}
                              </Select.Option>
                            ))}
                          </Select>
                        </div>
                      </Col>
                      <Col span={24}>
                        <BillingActivitiesList
                          data={
                            !_.isEmpty(this.state.filteredBillingActivitiesList)
                              ? this.state.filteredBillingActivitiesList
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                    : <div style={{ textAlign: "center" }}>No Activies Recorded</div>}

                </TabPane>}
              </Tabs>



          {this.props.showPictures && this.state.imagesVisible && this.renderUploadGallery()}
              { this.state.showDriverPayForm && this.renderDriverPayModal() }
          {this.state.showAddOrders && this.renderAddOrders()}
          {this.state.showEmailModal && this.renderEmailModal()}
          <PaperworkApprovalReasonModal
            visible={this.state.approvalReasonModalVisible}
            onCancel={this.closeApprovalReasonModal}
            onSubmit={this.handlePendingPaperworkApprove}
            loading={this.state.approveInProgress}
          />
          {this.state.openWarningModal && ( 
            <AlertModal
              visible={this.state.openWarningModal}
              type="warning" // "info" | "success" | "error"
              title={I18n.t("notifications.type.warning")}
              message={this.state.chargesLinesWarning}
              onClose={() =>
                this.setState({ openWarningModal: false, chargesLinesWarning: "" })
              }
            />
          )}
          <PdfPreviewViewer blobUrl={this.state.blobUrl} fileName={this.state.fileName} />


            { this.state.editForm && (
              <Drawer
                placement="right"
                closable={ false }
                maskClosable={ false }
                onClose={ this.closeEditFormModal }
                visible={ this.state.editForm }
                width="90%"
              >
                <EditOrderFormComponent
                  customerDetails={ this.state.currentOrder }
                  customerOrderId={ this.state.currentOrder.id }
                  preferences={ [] }
                  onCancel={ this.closeEditFormModal }
                  handleSuccess={ (message, isOutOfDispatch, isModified, newData) =>
                    this.handleOrderSaveSuccess(
                      message,
                      isOutOfDispatch,
                      isModified,
                      newData
                    )
                  }
                  currentRoute={ this.state.selectedRouteObject }
                  isNew={ false }
                  tab="accessorials"
                  screenFrom="billing"
                />
              </Drawer>
            ) }

            {this.state.openConfirmModal && this._renderHoldConfirmModal()} 

          </div>
        </div>
      </div>
      </Spin>
      </div>
    );
  }
}

Form.propTypes = {
  account: PropTypes.shape().isRequired,
  currentInvoice: PropTypes.shape().isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  getInvoiceDetails: PropTypes.func.isRequired,
  showHeaders: PropTypes.bool.isRequired,
  onUnmount : PropTypes.func.isRequired,
  handleIsLosChanged : PropTypes.func.isRequired,
  showPictures: PropTypes.bool.isRequired,
};

Form.defaultProps = {
  handleIsLosChanged : () => {},
  showPictures: true,
  callFrom: "billing",
  hideCloseButton: false,
  embeddedInBulk: false,
  bulkApprovalDescription: "",
  onPendingApproveSuccess: null,
};


export const BillingForm = withRouter((props) => {
  const warehouseFilter = useContext(WarehouseContext);
  const { orgSettings: organizationSettings, glCodesList } = useContext(OrgContext);
  const userContext = useContext(UserContext);
  const accountUnitContext = useContext(AccountUnitsContext);
  return (
    <Form
      accountUnitContext={accountUnitContext.accountWeightUnits}
      warehouseFilter={ warehouseFilter }
      organizationSettings={ organizationSettings }
      userContext={ userContext }
      glCodesList={ glCodesList }
      { ...props }
    />
  );
});

export default withRouter(BillingForm);